import React, { Component } from 'react';
import { publishFacts, clearFacts } from '../agent/bailey/skills/pageFacts';
import AlsoVisitsChip from '../multiLocation/AlsoVisitsChip';
import { connect } from 'react-redux';
import SlidePanel from '../shared/SlidePanel';
import { hairdresserActions } from '../../_actions';
import { formService } from '../../_services/form.service';
import { bookingService } from '../../_services/booking.service';
import moment from 'moment';
import dateFormat from 'dateformat';
import PhoneInput from 'react-phone-number-input';
import BirthdayPicker from './BirthdayPicker';
import ClientPhotosTab from './ClientPhotosTab';
import BookingDetailPanel from '../DiaryV2/BookingDetailPanel';
import LoyaltyCard from '../loyalty-v2/LoyaltyCard';
import { loadScheme as loadLoyaltyScheme, currentOwnerId as loyaltyOwnerId, hydrateLoyalty } from '../loyalty-v2/loyaltyStore';
import { clientPhotosActions } from '../../_actions/clientPhotos.actions';
import { magicLinkActions } from '../../_actions/magicLink.actions';
import { bookingActions } from '../../_actions/booking.actions';
import { clientSyncService } from '../../_services/clientSync.service';
import MergeClientsView from './MergeClientsView';
import '../shared/ui.css';
import './ClientDetailPanel.css';
import { marketingBackend } from "../marketing-v2/services/marketingBackend";
import RefundBadge from '../refunds/RefundBadge';
import { CLIENT_PHOTOS_VISIBLE, CONCIERGE_VISIBLE, PERMISSIONS_VISIBLE, MESSAGES_VISIBLE } from '../../config/featureFlags';
import { canSeeSpace } from '../messages/data/spaces';
import { diarySharingService } from '../../_services/diarySharing.service';
import ClientMessagesTab from './messages/ClientMessagesTab';
import toast from '../shared/Toast';
var _ = require('lodash');

// Client photos need SalonClient (photoConsent lives there), so they were
// hidden 2026-05-27 until the client-flow migration landed. Now per env:
// CLIENT_PHOTOS_VISIBLE in config/featureFlags. The render sites + prefetch
// are individually gated below.
const CLIENT_PHOTOS_ENABLED = CLIENT_PHOTOS_VISIBLE;

// Order used by the horizontal swipe gesture on mobile. Matches the
// visual order of tab buttons in renderTabs().
const TAB_ORDER = ['overview', 'bookings', 'notes', 'sales', 'wallet', 'forms', 'messages']
  .concat(CONCIERGE_VISIBLE ? ['bailey'] : [])
  .concat(CLIENT_PHOTOS_ENABLED ? ['photos'] : []);

class ClientDetailPanel extends Component {
  constructor(props) {
    super(props);
    this.slidePanelRef = React.createRef();
    this.magicLinkInputRef = React.createRef();
    this.state = {
      isLoading: true,
      // Allow caller (e.g. booking detail photos strip "See all" jump) to
      // pre-select a specific tab via props.initialTab.
      // If the caller asks for the photos tab but it's currently hidden,
      // fall back to overview so the panel doesn't open on a blank pane.
      activeTab: (!CLIENT_PHOTOS_ENABLED && props.initialTab === 'photos')
        ? 'overview'
        : (props.initialTab || 'overview'),
      // Stats
      totalSales: '0.00',
      totalBookingsCount: 0,
      lastVisit: null,
      recentBookings: [],
      rescheduledCount: 0,
      cancelledCount: 0,
      noShowCount: 0,
      // Bookings — lazy-loaded page 1 on tab open, "Load more" appends.
      // Past + upcoming paginate independently; the tab defaults to Past with
      // a Past/Upcoming toggle.
      bookingsSubTab: 'past',
      bookingsLoaded: false,
      pastBookings: [],
      pastBookingsPage: 0,
      pastBookingsHasMore: false,
      pastBookingsLoading: false,
      pastBookingsLoadingMore: false,
      pastBookingsError: false,
      upcomingBookings: [],
      upcomingBookingsPage: 0,
      upcomingBookingsHasMore: false,
      upcomingBookingsLoading: false,
      upcomingBookingsLoadingMore: false,
      upcomingBookingsError: false,
      // Sales — lazy-loaded page 1 on tab open, "Load more" appends.
      salesLoaded: false,
      salesItems: [],
      salesPage: 0,
      salesHasMore: false,
      salesLoading: false,
      salesLoadingMore: false,
      salesError: false,
      // Notes
      editingNote: false,
      noteText: '',
      savingNote: false,
      // Forms — lazy-loaded page 1 on tab open, "Load more" appends.
      clientForms: [],
      clientFormsLoading: false,
      clientFormsLoadingMore: false,
      clientFormsPage: 0,
      clientFormsHasMore: false,
      formsLoaded: false,
      showSendFormModal: false,
      availableForms: [],
      availableFormsLoading: false,
      sendingFormId: null,
      // Resend confirmation
      resendingBookingId: null,
      resentBookingIds: [],
      // Edit mode
      editMode: false,
      editFirstName: '',
      editLastName: '',
      editEmail: '',
      editPhone: '',
      editNote: '',
      editDob: '',
      editSaving: false,
      editError: '',
      editEmailError: '',
      showBirthdayPicker: false,
      // Delete / Menu
      deleteClientModal: false,
      showMoreMenu: false,
      // Magic link (client claim/login) — client-flow §5.6
      magicLinkSending: false,
      magicLinkMessage: '',
      magicLinkUrl: '',
      magicLinkCopied: false,
      // Merge suggestion (§7.3 — edited email matched an existing account)
      mergeSuggestion: null,
      mergeView: false,
      // Pending client updates (client self-edits awaiting salon review) — §6
      pendingUpdates: [],
      // Message tab: nested sub-tabs (received messages / consent audit trail)
      messageSubTab: 'messages',
      // Journey membership for this client — which journeys they're in and
      // where they've got to. Lazily loaded with the Messages tab.
      journeyRuns: [],
      journeysLoading: false,
      journeysLoaded: false,
      // Consent history (audit trail + current marketable state + suppressions).
      // Paginated: history + suppressions grow via "Load more".
      consentHistory: null,
      consentCurrent: null,
      consentSuppressions: [],
      consentLoading: false,
      consentLoadingMore: false,
      consentLoaded: false,
      consentError: false,
      consentPage: 0,
      consentHasMore: false,
      // Marketing messages sub-tab — paginated, "Load more" appends.
      clientMessages: [],
      messagesLoading: false,
      messagesLoadingMore: false,
      messagesLoaded: false,
      messagesError: false,
      messagesPage: 0,
      messagesHasMore: false,
      // Loyalty history — paginated, "Load more" appends.
      loyaltyHistoryPage: 0,
      loyaltyHistoryHasMore: false,
      loyaltyHistoryLoadingMore: false,
    };
  }

  componentWillUnmount() {
    clearFacts('client-open');
  }

  // Tell Bailey which client is open, so "when was she last in?" or "is this
  // client overdue?" asked from the pet means this one. Published once per
  // client, when their details have loaded.
  _tellBailey() {
    try {
      const client = this.props.clientDetail?.clientDetail;
      if (!client || String(client._id) !== String(this.props.clientId)) return;
      const name = client.name || [client.first_name, client.last_name].filter(Boolean).join(' ') || 'this client';
      const key = `${client._id}:${name}`;
      if (this._toldBailey === key) return;
      this._toldBailey = key;
      publishFacts('client-open', {
        path: `/${(window.location.pathname.split('/')[1] || '')}`,
        lines: [`Client open: ${name}`],
        entity: { type: 'client', id: String(client._id), label: name },
      });
    } catch (e) { /* only for Bailey */ }
  }

  componentDidMount() {
    this.fetchClientDetails();
    this.fetchPendingUpdates();
    // Whose diary columns this person can see (server rule, access audit
    // 2026-10-02): a booking in a hidden column can't be opened here either.
    diarySharingService.fetchMyVisibility()
      .then((v) => this.setState({ diaryCanSee: new Set((v.canSee || []).map(String)), diaryIAmOwner: !!v.iAmOwner }))
      .catch(() => { /* unknown: let the server decide */ });
    // Opening straight onto a tab (props.initialTab) skips switchTab, so the
    // tab's lazy load has to start here too. Otherwise a deep-linked wallet
    // says "no stamps", and ?tab=bookings sat on "Loading bookings..." forever.
    this.loadTabData(this.state.activeTab);
    if (this.props.initialAction === 'delete') {
      // Opened from the list's "Delete Client": confirm only once the server
      // has said this person may remove this client (fetchClientDetails).
      this.pendingDelete = true;
    }
  }

  // "Book" from a list row (e.g. a client found at another of your locations):
  // once the client has loaded, open the new-booking panel with them selected.
  componentDidUpdate() {
    this._tellBailey();
    if (this.props.initialAction === 'book' && !this._bookOpened) {
      const client = this.props.clientDetail?.clientDetail;
      if (client && String(client._id) === String(this.props.clientId)) {
        this._bookOpened = true;
        this.openNewBookingPanel();
      }
    }
  }

  // ----- Client-flow: pending updates (spec §6) -----
  fetchPendingUpdates() {
    if (!this.props.clientId) return;
    clientSyncService.listPendingByClientUserId(this.props.clientId)
      .then((res) => {
        const list = res?.data?.responseData?.result || res?.data?.data?.result || [];
        this.setState({ pendingUpdates: Array.isArray(list) ? list : [] });
      })
      .catch(() => this.setState({ pendingUpdates: [] }));
  }

  handleAcceptPending = (id) => {
    clientSyncService.acceptPending(id)
      .then(() => { this.fetchPendingUpdates(); this.fetchClientDetails(); })
      .catch((err) => console.warn('Accept pending failed', err && err.message));
  }

  handleDismissPending = (id) => {
    clientSyncService.dismissPending(id)
      .then(() => this.fetchPendingUpdates())
      .catch((err) => console.warn('Dismiss pending failed', err && err.message));
  }

  // Inline "client updated X" banner under the matching contact/detail row.
  renderPendingUpdateFor(field) {
    const pu = (this.state.pendingUpdates || []).find(p => p.field === field);
    if (!pu) return null;
    return (
      <div className="cdp-pending-update" style={{
        margin: '4px 0 8px', padding: '8px 10px',
        background: '#fff7e6', border: '1px solid #ffe7a3',
        borderRadius: 8, fontSize: 13, color: '#664d03',
      }}>
        <div style={{ marginBottom: 6 }}>
          Client updated to <strong>{pu.newValue || '(empty)'}</strong>
          {pu.createdAt ? <span style={{ color: '#998a4a' }}> · {moment(pu.createdAt).format('DD MMM')}</span> : null}
        </div>
        <button onClick={() => this.handleAcceptPending(pu._id)}
          style={{ marginRight: 8, padding: '4px 12px', borderRadius: 6, border: '1px solid #007EA0', background: '#007EA0', color: '#fff', fontSize: 12, cursor: 'pointer' }}>
          Accept update
        </button>
        <button onClick={() => this.handleDismissPending(pu._id)}
          style={{ padding: '4px 12px', borderRadius: 6, border: '1px solid #ccc', background: '#fff', color: '#555', fontSize: 12, cursor: 'pointer' }}>
          Ignore
        </button>
      </div>
    );
  }

  // ----- Client-flow: magic link (spec §5.6) -----
  // skipEmail=false → "Send login link": BE emails the client + returns the
  // link. skipEmail=true → "Copy login link": BE issues WITHOUT emailing and
  // we copy it straight to the clipboard for the salon to share themselves.
  sendMagicLink = (skipEmail = false) => {
    const self = this;
    const clientUserId = this.props.clientId;
    if (!clientUserId || this.state.magicLinkSending) return;
    self.setState({ magicLinkSending: true });
    self.props.dispatch(magicLinkActions.sendToClient(skipEmail ? { clientUserId, skipEmail: true } : { clientUserId }))
      .then(function (response) {
        // The API reports failures as HTTP 200 + {statusCode:0, error} — a
        // transport-level .catch never sees them. Surface the real reason
        // (e.g. "Client has no real email", rate limit) instead of a silent
        // no-op toast with no link.
        if (response?.data?.statusCode === 0) {
          const msg = response?.data?.error?.responseMessage || 'Could not create the link. Please try again.';
          self.setState({ magicLinkSending: false, magicLinkMessage: `Error: ${msg}`, magicLinkUrl: '' });
          setTimeout(() => self.setState({ magicLinkMessage: '' }), 6000);
          return;
        }
        const data = response?.data?.responseData || response?.data?.data || {};
        const purposeLabel = data.purpose === 'claim' ? 'Claim link' : 'Login link';
        const message = skipEmail
          ? `${purposeLabel} ready. Valid 24h, single use.`
          : `${purposeLabel} sent to ${data.sentTo || 'their email'}.`;
        // Keep the block up while the link is showing — the salon needs time
        // to copy/share it. Dismissed via the ✕ or by closing the panel.
        self.setState({
          magicLinkSending: false,
          magicLinkMessage: message,
          magicLinkUrl: data.link || '',
          magicLinkCopied: false,
        }, () => {
          // Auto-copy AFTER the input renders so the synchronous
          // select+execCommand path (the reliable one) has a target.
          if (skipEmail && data.link) self.copyMagicLink(data.link);
        });
        if (!data.link) setTimeout(() => self.setState({ magicLinkMessage: '' }), 4000);
      })
      .catch(function (err) {
        const msg = err?.response?.data?.message || err?.message || 'Failed to send link';
        self.setState({ magicLinkSending: false, magicLinkMessage: `Error: ${msg}`, magicLinkUrl: '' });
        setTimeout(() => self.setState({ magicLinkMessage: '' }), 5000);
      });
  }

  copyMagicLink = (urlArg) => {
    const url = (typeof urlArg === 'string' && urlArg) || this.state.magicLinkUrl;
    if (!url) return;
    const done = () => {
      this.setState({ magicLinkCopied: true });
      setTimeout(() => this.setState({ magicLinkCopied: false }), 2000);
    };

    // 1) Synchronous path FIRST: select the visible input and execCommand.
    //    navigator.clipboard.writeText silently fails in exactly the cases
    //    that bite here — DevTools focused ("document is not focused"), the
    //    user gesture expired after the network round-trip, webview policy.
    //    execCommand inside the same tick of a click keeps the gesture.
    const input = this.magicLinkInputRef && this.magicLinkInputRef.current;
    if (input) {
      try {
        input.focus();
        input.select();
        input.setSelectionRange(0, url.length);
        if (document.execCommand('copy')) { done(); return; }
      } catch (e) { /* fall through */ }
    }

    // 2) Async clipboard API.
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(() => this._copyFallback(url, done));
    } else {
      this._copyFallback(url, done);
    }
  }

  _copyFallback(url, done) {
    // 3) Detached-textarea execCommand for anything left. If even this fails
    //    the field is visible and auto-selected — manual Cmd+C still works.
    const ta = document.createElement('textarea');
    ta.value = url;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); done(); } catch (e) { /* leave link visible to copy by hand */ }
    document.body.removeChild(ta);
    // Re-select the visible input so a manual Cmd+C lands on the link.
    const input = this.magicLinkInputRef && this.magicLinkInputRef.current;
    if (input) { try { input.focus(); input.select(); } catch (e) { /* noop */ } }
  }

  // Panel-open fetch: SUMMARY ONLY. The client-detail call with summary:true
  // returns clientDetail + counts + a ~5-item recentBookings preview + sales
  // totals, NOT the full booking/sales history — those load per-tab on demand.
  // Keeps the panel cheap for clients with thousands of records.
  fetchClientDetails() {
    const self = this;
    self.setState({ isLoading: true });
    self.props.dispatch(hairdresserActions.getHairdresserClientDetail({
      userId: this.props.clientId,
      hairdresserId: localStorage.getItem('userId'),
      bookingType: 'past',
      summary: true,
    }))
      .then(function () {
        const detail = self.props.clientDetail || {};
        const count = detail.count || [];
        const rescheduled = _.find(count, o => o._id === 5) || {};
        const cancelled = _.find(count, o => o._id === 3) || {};
        const noShow = _.find(count, o => o._id === 6) || {};
        const recent = Array.isArray(detail.recentBookings) ? detail.recentBookings : [];
        // Prefer explicit summary totals; fall back to legacy fields so an
        // older/non-summary payload still populates the Overview.
        const bookingCount = detail.totalBookingsCount != null
          ? detail.totalBookingsCount
          : (detail.pastBooking?.length || 0) + (detail.upcomingBookings?.length || 0);
        self.setState({
          rescheduledCount: rescheduled.count || 0,
          cancelledCount: cancelled.count || 0,
          noShowCount: noShow.count || 0,
          totalSales: detail.totalServiceSales || '0.00',
          // Spend is net of refunds (docs/refunds.md); the refunded part is named beside it.
          totalRefunded: Number(detail.totalRefunded) || 0,
          totalBookingsCount: bookingCount,
          lastVisit: detail.lastVisit || null,
          recentBookings: recent,
          // What the server will let this person do with the client (null =
          // an older API that doesn't say: fall back to the legacy gate).
          clientActions: detail.clientActions || null,
          isLoading: false,
        }, () => {
          if (!self.pendingDelete) return;
          self.pendingDelete = false;
          if (self.canClientAction('canRemove')) self.setState({ deleteClientModal: true });
          else toast.error("You can't remove this client. Only their stylist, or someone who can see all clients, can.");
        });
      })
      .catch(function () {
        self.setState({ isLoading: false });
      });
  }

  checkEmail = (email) => {
    const parts = email?.split('@');
    return parts?.[1] !== 'beuapp.com';
  }

  checkReadOnly = () => {
    const h = this.props.user?.userInfo?.hairdresser;
    return h?.isSalonOwner === 1 || (h?.isSalonOwner === 0 && h?.employmentTypeId === 2);
  }

  // Roles & permissions (access audit 2026-10-02): an action shows only when
  // the server would allow it — clientActions comes from the client summary
  // and applies the same rules as edit / delete / login link. Flag off keeps
  // the legacy who-sees-the-menu gate on top.
  canClientAction = (key) => {
    const base = PERMISSIONS_VISIBLE ? true : this.checkReadOnly();
    if (!base) return false;
    const a = this.state.clientActions;
    return a ? !!a[key] : this.checkReadOnly();
  }

  // A booking in a diary column this person can't see opens nowhere (the
  // server refuses it, same rule as the diary).
  canOpenBooking = (booking) => {
    const seen = this.state.diaryCanSee;
    if (!seen || this.state.diaryIAmOwner) return true;
    const stylist = String((booking && booking.hairdresserId && (booking.hairdresserId._id || booking.hairdresserId)) || '');
    return !stylist || seen.has(stylist);
  }

  navigateAway = (path) => {
    if (this.slidePanelRef.current) {
      this.slidePanelRef.current.handleClose();
    }
    setTimeout(() => {
      this.props.history.push(path);
    }, 320);
  }

  // "New Booking" used to route to the legacy /newbooking/:salonId page, which
  // threw the user out of the client they were looking at and made them search
  // for that same client again. The create-booking sidebar replaced that flow,
  // so open it in place with the client already selected.
  //
  // Falls back to the legacy route if the staff list can't be fetched: the
  // panel hides its staff picker when staffList is empty, which would leave a
  // booking with no stylist and no loadable services — worse than the old page.
  openNewBookingPanel = () => {
    const client = this.props.clientDetail?.clientDetail;
    if (!client) return;

    const legacyFallback = () => this.navigateAway('/newbooking/' + localStorage.getItem('salonId'));
    const hairdresserId = localStorage.getItem('userId');

    this.props.dispatch(hairdresserActions.hairdresserStaffRota({
      searchKey: '', hairdresserId, page: 1, listType: 1,
    })).then((res) => {
      const rota = res?.data?.data?.rota || [];
      // StaffPicker keys off `id`; the rota returns `_id`.
      const staffList = rota.filter(s => s && s.name).map(s => ({ ...s, id: s._id || s.id }));
      if (!staffList.length) return legacyFallback();

      // Seed with the logged-in staff member where they're bookable, else the
      // first — same default the diary uses for a booking with no slot.
      const mine = staffList.find(s => s.id === hairdresserId);

      this.props.dispatch(bookingActions.openMinimisedBooking({
        staffId: (mine || staffList[0]).id,
        bookingDate: new Date(),
        staffList,
        currencySymbol: this.props.user?.userInfo?.hairdresser?.currencySymbol || '£',
        // The panel reads its preselected client from `rebookClient`.
        rebookClient: {
          _id: client._id,
          name: client.name,
          email: client.email,
          phoneNumber: client.phoneNumber,
        },
      }));

      // NewBookingHost lives at the router level, so the sidebar survives this
      // panel closing — no navigation needed.
      if (this.slidePanelRef.current) this.slidePanelRef.current.handleClose();
    }).catch(legacyFallback);
  }

  switchTab = (tab) => {
    this.setState({ activeTab: tab }, () => this.loadTabData(tab));
  }

  // What each tab loads the first time it's shown (by switching to it, or by
  // opening straight onto it).
  loadTabData = (tab) => {
    if (tab === 'bookings' && !this.state.bookingsLoaded) {
      this.loadBookings();
    }
    if (tab === 'sales' && !this.state.salesLoaded) {
      this.loadSales();
    }
    if (tab === 'forms' && !this.state.formsLoaded) {
      this.loadClientForms();
    }
    if (tab === 'wallet' && !this.state.loyaltyCardLoaded) {
      this.loadLoyaltyCard();
    }
    if (CLIENT_PHOTOS_ENABLED && tab === 'bookings' && !this.state.photosPrefetched) {
      // Prefetch photos so the Bookings tab can show thumbnail strips.
      this.setState({ photosPrefetched: true });
      this.props.dispatch(clientPhotosActions.fetchPhotos(this.props.clientId));
    }
  }

  // ── Horizontal swipe between tabs ─────────────────────────────
  // Touch handlers on the tab content wrapper. Only hijack the gesture
  // when horizontal movement clearly dominates so nested vertical
  // scrolling (notes textarea, bookings list, photos timeline) isn't
  // broken.
  _swipeStart = null;

  handleContentTouchStart = (e) => {
    if (e.touches.length !== 1) return;
    const t = e.touches[0];
    this._swipeStart = { x: t.clientX, y: t.clientY, locked: null };
  }

  handleContentTouchMove = (e) => {
    if (!this._swipeStart || e.touches.length !== 1) return;
    const t = e.touches[0];
    const dx = t.clientX - this._swipeStart.x;
    const dy = t.clientY - this._swipeStart.y;
    if (!this._swipeStart.locked) {
      // Lock to horizontal only if the user's first 10px of movement
      // is clearly horizontal. Otherwise lock to vertical so native
      // scrolling takes over and we don't interfere.
      if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        this._swipeStart.locked = 'x';
      } else if (Math.abs(dy) > 10) {
        this._swipeStart.locked = 'y';
      }
    }
  }

  handleContentTouchEnd = (e) => {
    const start = this._swipeStart;
    this._swipeStart = null;
    if (!start || start.locked !== 'x') return;
    const t = (e.changedTouches && e.changedTouches[0]) || null;
    if (!t) return;
    const dx = t.clientX - start.x;
    if (Math.abs(dx) < 70) return; // below threshold, no change
    const currentIdx = TAB_ORDER.indexOf(this.state.activeTab);
    if (currentIdx === -1) return;
    // dx > 0 means finger moved right → show previous tab
    const nextIdx = dx > 0 ? currentIdx - 1 : currentIdx + 1;
    if (nextIdx < 0 || nextIdx >= TAB_ORDER.length) return;
    this.switchTab(TAB_ORDER[nextIdx]);
  }

  // Notes
  handleEditNote = () => {
    const clientDetail = this.props.clientDetail?.clientDetail;
    this.setState({ editingNote: true, noteText: clientDetail?.note || '' });
  }

  handleCancelNote = () => {
    this.setState({ editingNote: false, noteText: '' });
  }

  // One-tap marketing-consent toggle from the Overview tab; sparse update
  // through the same client/edit endpoint the notes editor uses
  handleToggleConsent = (field, value) => {
    const self = this;
    self.setState({ [`saving_${field}`]: true });
    self.props.dispatch(hairdresserActions.editClient({
      hairdresserId: localStorage.getItem('userId'),
      userId: this.props.clientId,
      [field]: value,
    }))
      .then(function () {
        self.props.dispatch(hairdresserActions.getHairdresserClientDetail({
          userId: self.props.clientId,
          hairdresserId: localStorage.getItem('userId'),
          bookingType: 'past',
          summary: true,
        })).then(function () {
          self.setState({ [`saving_${field}`]: false });
        });
      })
      .catch(function () { self.setState({ [`saving_${field}`]: false }); });
  }

  renderConsentToggle = (field) => {
    const detail = this.props.clientDetail?.clientDetail;
    // Marketing consent is OPT-OUT (soft opt-in): a client is marketable unless
    // the stored value is EXPLICITLY false. null/undefined (never set) → ON.
    const value = detail?.[field] !== false;
    const saving = this.state[`saving_${field}`];
    return (
      <button
        type="button"
        role="switch"
        aria-checked={value}
        disabled={saving}
        onClick={() => this.handleToggleConsent(field, !value)}
        style={{
          width: 44, height: 26, borderRadius: 100, border: 'none', cursor: 'pointer', padding: 2,
          background: value ? '#007EA0' : '#DEDEE2', opacity: saving ? 0.6 : 1,
          transition: 'background 0.15s', flexShrink: 0
        }}
      >
        <span style={{
          display: 'block', width: 22, height: 22, borderRadius: '50%', background: '#fff',
          boxShadow: '0 1px 3px rgba(0,0,0,0.25)', transition: 'transform 0.15s',
          transform: value ? 'translateX(18px)' : 'translateX(0)'
        }} />
      </button>
    );
  }

  handleSaveNote = () => {
    const self = this;
    self.setState({ savingNote: true });
    self.props.dispatch(hairdresserActions.editClient({
      hairdresserId: localStorage.getItem('userId'),
      userId: this.props.clientId,
      note: this.state.noteText,
    }))
      .then(function (response) {
        if (response.data.errorCode) {
          self.setState({ savingNote: false });
        } else {
          self.props.dispatch(hairdresserActions.getHairdresserClientDetail({
            userId: self.props.clientId,
            hairdresserId: localStorage.getItem('userId'),
            bookingType: 'past',
            summary: true,
          })).then(function () {
            self.setState({ editingNote: false, noteText: '', savingNote: false });
          });
        }
      });
  }

  // Forms — page 1 on tab open, "Load more" appends the next page.
  PAGE_SIZE = 25;

  loadClientForms = () => {
    this.setState({ clientFormsLoading: true });
    formService.listSubmissions({ userId: this.props.clientId, page: 1, limit: this.PAGE_SIZE })
      .then((response) => {
        const data = response.data?.responseData || {};
        this.setState({
          clientForms: data.result || [],
          clientFormsPage: data.page || 1,
          clientFormsHasMore: !!data.hasMore,
          clientFormsLoading: false,
          formsLoaded: true,
        });
      })
      .catch(() => {
        this.setState({ clientForms: [], clientFormsLoading: false, formsLoaded: true, clientFormsHasMore: false });
      });
  }

  loadMoreClientForms = () => {
    if (this.state.clientFormsLoadingMore || !this.state.clientFormsHasMore) return;
    const nextPage = (this.state.clientFormsPage || 1) + 1;
    this.setState({ clientFormsLoadingMore: true });
    formService.listSubmissions({ userId: this.props.clientId, page: nextPage, limit: this.PAGE_SIZE })
      .then((response) => {
        const data = response.data?.responseData || {};
        this.setState((s) => ({
          clientForms: [...s.clientForms, ...(data.result || [])],
          clientFormsPage: data.page || nextPage,
          clientFormsHasMore: !!data.hasMore,
          clientFormsLoadingMore: false,
        }));
      })
      .catch(() => this.setState({ clientFormsLoadingMore: false }));
  }

  loadAvailableForms = () => {
    this.setState({ availableFormsLoading: true });
    formService.listForms({ status: 'active', formType: 'manual' })
      .then((response) => {
        const data = response.data?.responseData || {};
        this.setState({ availableForms: data.result || [], availableFormsLoading: false });
      })
      .catch(() => {
        this.setState({ availableForms: [], availableFormsLoading: false });
      });
  }

  openSendFormModal = () => {
    this.loadAvailableForms();
    this.setState({ showSendFormModal: true });
  }

  handleSendForm = (formTemplateId) => {
    this.setState({ sendingFormId: formTemplateId });
    formService.sendForm({ formTemplateId, userId: this.props.clientId })
      .then(() => {
        this.setState({ showSendFormModal: false, sendingFormId: null });
        this.loadClientForms();
      })
      .catch(() => { this.setState({ sendingFormId: null }); });
  }

  // Delete
  deleteClient = () => {
    const self = this;
    self.props.dispatch(hairdresserActions.deleteClient({
      hairdresserId: localStorage.getItem('userId'),
      userId: this.props.clientId,
    }))
      .then(function (response) {
        // v2 signals success with statusCode 1 (and no errorCode); guard on
        // both so a v2 failure isn't mistaken for success.
        const ok = !response.data.errorCode && response.data.statusCode !== 0;
        if (ok) {
          self._didDelete = true;
          self.setState({ deleteClientModal: false });
          if (self.slidePanelRef.current) {
            self.slidePanelRef.current.handleClose();
          }
        }
      });
  }

  // Edit client
  handleEditClient = () => {
    const detail = this.props.clientDetail?.clientDetail;
    const email = detail?.email || '';
    const emailParts = email.split('@');
    const showEmail = emailParts[1] === 'beuapp.com' ? '' : email;

    this.setState({
      editMode: true,
      editFirstName: detail?.first_name && detail.first_name !== '' ? detail.first_name : (detail?.name || ''),
      editLastName: detail?.last_name || '',
      editEmail: showEmail,
      editPhone: detail?.phoneNumber ? this.getPhoneNumber(detail.phoneNumber) : '',
      editNote: detail?.note || '',
      editDob: detail?.dob && detail.dob !== '' ? new Date(moment(detail.dob, 'DD-MM-YYYY')) : '',
      editError: '',
      editEmailError: '',
    });
  }

  getPhoneNumber = (phone) => {
    if (!phone) return '';
    const str = phone.toString();
    if (str.startsWith('+')) return str;
    if (str.startsWith('0')) return '+44' + str.substring(1);
    return '+' + str;
  }

  validateEmail = (email) => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(email);
  }

  saveEditClient = () => {
    const { editFirstName, editLastName, editEmail, editPhone, editNote, editDob } = this.state;

    if (!editFirstName.trim()) {
      this.setState({ editError: 'Please enter first name' });
      return;
    }
    if (editEmail && !this.validateEmail(editEmail)) {
      this.setState({ editEmailError: 'Please enter a valid email address' });
      return;
    }

    this.setState({ editSaving: true, editError: '', editEmailError: '' });
    const self = this;
    const params = {
      hairdresserId: localStorage.getItem('userId'),
      userId: this.props.clientId,
      name: (editFirstName + ' ' + editLastName).trim(),
      first_name: editFirstName,
      last_name: editLastName,
      email: editEmail,
      phoneNumber: editPhone,
      note: editNote,
      dob: editDob ? dateFormat(editDob, 'dd-mm-yyyy') : '',
    };

    self.props.dispatch(hairdresserActions.editClient(params))
      .then(function (response) {
        self.setState({ editSaving: false });
        if (response.data.errorCode) {
          if (response.data.errorCode === 51) {
            self.setState({ editEmailError: response.data.messages });
          } else {
            self.setState({ editError: response.data.messages });
          }
        } else {
          // §7.3 — the BE returns a mergeSuggestion when the edited email
          // matches an existing User (typo-corrected duplicate). Surface the
          // banner so the salon can opt in to merging the two records.
          const responseData = response.data?.responseData || response.data?.data;
          const suggestion = responseData?.mergeSuggestion;
          self.setState({
            editMode: false,
            mergeSuggestion: (suggestion && suggestion.matchingUserId) ? suggestion : null,
          });
          self.fetchClientDetails();
          // Tell the parent list to patch this row in place — otherwise the
          // list keeps showing the pre-edit name until a full reload.
          if (self.props.onClientUpdated) {
            self.props.onClientUpdated({
              userId: self.props.clientId,
              name: params.name,
              first_name: params.first_name,
              last_name: params.last_name,
              email: params.email,
              phoneNumber: params.phoneNumber,
              dob: params.dob,
            });
          }
        }
      })
      .catch(() => {
        self.setState({ editSaving: false, editError: 'Something went wrong' });
      });
  }

  // Resend booking confirmation
  handleResendConfirmation = (bookingId, e) => {
    e.stopPropagation();
    this.setState({ resendingBookingId: bookingId });
    bookingService.resendBookingConfirmation(bookingId)
      .then((res) => {
        // v2 answers refusals with statusCode 0 in a 200, so only a real send counts as Sent.
        const body = res && res.data;
        if (body && body.statusCode === 1) {
          this.setState(prev => ({
            resendingBookingId: null,
            resentBookingIds: [...prev.resentBookingIds, bookingId],
          }));
        } else {
          this.setState({ resendingBookingId: null });
          toast.error((body && body.error && body.error.responseMessage) || 'Could not resend the confirmation');
        }
      })
      .catch(() => {
        this.setState({ resendingBookingId: null });
        toast.error('Could not resend the confirmation');
      });
  }

  // Helpers
  getServiceName = (booking) => {
    return booking.servicesBooked?.map(s => s?.service?.serviceName || s?.serviceName || 'Service').join(', ') || 'Booking';
  }

  getSlotTime = (time) => {
    const hr = parseInt(time / 60);
    const min = time - (hr * 60);
    return hr + ':' + (min === 0 ? '00' : min < 10 ? '0' + min : min);
  }

  getTotalPrice = (booking) => {
    let total = 0;
    if (booking.servicesBooked) {
      booking.servicesBooked.forEach(s => { total += s.servicePrice || 0; });
    }
    return total;
  }

  getBookingStatusClass = (booking) => {
    const status = booking.bookingStatus || booking.bookingStatusId;
    switch (status) {
      case 4: return 'completed';
      case 3: case 6: return 'cancelled';
      default: return 'upcoming';
    }
  }

  getBookingStatusPill = (booking) => {
    const status = booking.bookingStatus ?? booking.bookingStatusId;
    const map = {
      0: { label: 'Pending', css: 'cdp-status-pill--pending' },
      1: { label: 'Booked', css: 'cdp-status-pill--booked' },
      2: { label: 'Confirmed', css: 'cdp-status-pill--confirmed' },
      3: { label: 'Cancelled', css: 'cdp-status-pill--cancelled' },
      4: { label: 'Completed', css: 'cdp-status-pill--completed' },
      5: { label: 'Rescheduled', css: 'cdp-status-pill--rescheduled' },
      6: { label: 'No Show', css: 'cdp-status-pill--noshow' },
    };
    return map[status] || { label: 'Unknown', css: '' };
  }

  // ========================
  // RENDER
  // ========================

  renderSkeleton() {
    return (
      <>
        <div className="cdp-header" style={{ gap: 14 }}>
          <div className="cdp-skeleton">
            <div className="cdp-skel-bar" style={{ width: 44, height: 44, borderRadius: '50%' }} />
          </div>
          <div className="cdp-skeleton" style={{ flex: 1 }}>
            <div className="cdp-skel-bar" style={{ width: 120, height: 16, marginBottom: 6 }} />
            <div className="cdp-skel-bar" style={{ width: 180, height: 12 }} />
          </div>
        </div>
        <div className="cdp-summary cdp-skeleton">
          <div className="cdp-skel-bar" style={{ width: '100%', height: 14 }} />
        </div>
        <div className="cdp-tabs cdp-skeleton">
          <div className="cdp-skel-bar" style={{ width: 200, height: 14, margin: '14px 0' }} />
        </div>
        <div className="cdp-tab-content cdp-skeleton">
          <div className="cdp-skel-bar" style={{ width: '100%', height: 44, marginBottom: 20, borderRadius: 10 }} />
          {[1, 2, 3, 4].map(i => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0' }}>
              <div className="cdp-skel-bar" style={{ width: 80, height: 14 }} />
              <div className="cdp-skel-bar" style={{ width: 140, height: 14 }} />
            </div>
          ))}
        </div>
      </>
    );
  }

  renderHeader() {
    const client = this.props.clientDetail?.clientDetail;
    if (!client) return null;
    const initials = client.name?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) || 'C';
    const { showMoreMenu } = this.state;

    return (
      <div className="cdp-header">
        {client.localAvatar ? (
          <div className="cdp-header-avatar"><img src={client.localAvatar} alt="" /></div>
        ) : (
          <div className="cdp-header-avatar-initials">{initials}</div>
        )}
        <div className="cdp-header-info">
          <h2 className="cdp-header-name">{client.name}</h2>
          <p className="cdp-header-sub">
            {this.checkEmail(client.email) ? client.email : client.phoneNumber || ''}
          </p>
          <AlsoVisitsChip clientUserId={this.props.clientId} />
        </div>
        <div className="cdp-header-actions">
          {/* Beu Messages: open their chat on the Messages tab */}
          {MESSAGES_VISIBLE && canSeeSpace('clients') && (
            <button type="button" className="beu-icon-btn" aria-label={`Message ${client.name || 'this client'}`} title="Message"
              onClick={() => { this.switchTab('messages'); this.setState({ openChatAt: Date.now() }); }}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M14 10a1.3 1.3 0 0 1-1.3 1.3H5L2 14V3.3A1.3 1.3 0 0 1 3.3 2h9.4A1.3 1.3 0 0 1 14 3.3z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </button>
          )}
          {(this.canClientAction('canEdit') || this.canClientAction('canRemove') || this.canClientAction('canSendLoginLink')) && (
            <div style={{ position: 'relative' }}>
              <button className="beu-icon-btn" onClick={() => this.setState({ showMoreMenu: !showMoreMenu })}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <circle cx="12" cy="5" r="1.5" />
                  <circle cx="12" cy="12" r="1.5" />
                  <circle cx="12" cy="19" r="1.5" />
                </svg>
              </button>
              {showMoreMenu && (
                <>
                  <div style={{ position: 'fixed', inset: 0, zIndex: 9 }} onClick={() => this.setState({ showMoreMenu: false })} />
                  <div className="cdp-menu-dropdown">
                    {this.canClientAction('canEdit') && <button className="cdp-menu-item" onClick={() => { this.setState({ showMoreMenu: false }); this.handleEditClient(); }}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
                      Edit Client
                    </button>}
                    {this.canClientAction('canSendLoginLink') && <button className="cdp-menu-item" disabled={this.state.magicLinkSending}
                      onClick={() => { this.setState({ showMoreMenu: false }); this.sendMagicLink(); }}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 2L11 13" /><path d="M22 2l-7 20-4-9-9-4 20-7z" /></svg>
                      {this.state.magicLinkSending ? 'Sending link…' : 'Send login link'}
                    </button>}
                    {this.canClientAction('canRemove') && <button className="cdp-menu-item cdp-menu-item--danger" onClick={() => { this.setState({ showMoreMenu: false, deleteClientModal: true }); }}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>
                      Delete Client
                    </button>}
                  </div>
                </>
              )}
            </div>
          )}
          <button className="beu-icon-btn" onClick={() => this.slidePanelRef.current?.handleClose()}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      </div>
    );
  }

  renderSummaryBar() {
    // Booking count comes from the cheap summary payload (totalBookingsCount),
    // NOT from counting loaded arrays — the full history is never fetched here.
    const totalBookings = this.state.totalBookingsCount || 0;
    const client = this.props.clientDetail?.clientDetail;

    return (
      <div className="cdp-summary">
        <div className="cdp-summary-item">
          <span className="cdp-summary-value">&pound;{(parseFloat(String(this.state.totalSales || 0).replace(/,/g, '')) || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span> spent
          {this.state.totalRefunded > 0 && (
            <span style={{ color: '#9ca3af' }}> after &pound;{this.state.totalRefunded.toFixed(2)} refunded</span>
          )}
        </div>
        <div className="cdp-summary-item">
          <span className="cdp-summary-value">{totalBookings}</span> bookings
        </div>
        {this.state.lastVisit && (
          <div className="cdp-summary-item">
            Last visit <span className="cdp-summary-value">{moment(this.state.lastVisit).format(moment(this.state.lastVisit).isSame(moment(), 'year') ? 'D MMM' : 'D MMM YYYY')}</span>
          </div>
        )}
        {client?.createdAt && (
          <div className="cdp-summary-item">
            Joined <span className="cdp-summary-value">{moment(client.createdAt).format('MMM YYYY')}</span>
          </div>
        )}
      </div>
    );
  }

  renderTabs() {
    const { activeTab } = this.state;
    return (
      <div className="cdp-tabs">
        <button className={`cdp-tab${activeTab === 'overview' ? ' active' : ''}`} onClick={() => this.switchTab('overview')}>
          Overview
        </button>
        <button className={`cdp-tab${activeTab === 'bookings' ? ' active' : ''}`} onClick={() => this.switchTab('bookings')}>
          Bookings
        </button>
        {/* Client notes are their own permission ("Client notes and forms"):
            the server leaves the note out and says so (notesHidden). */}
        {!this.props.clientDetail?.clientDetail?.notesHidden && (
          <button className={`cdp-tab${activeTab === 'notes' ? ' active' : ''}`} onClick={() => this.switchTab('notes')}>
            Notes
          </button>
        )}
        <button className={`cdp-tab${activeTab === 'sales' ? ' active' : ''}`} onClick={() => this.switchTab('sales')}>
          Sales
        </button>
        <button className={`cdp-tab${activeTab === 'wallet' ? ' active' : ''}`} onClick={() => this.switchTab('wallet')}>
          Wallet
        </button>
        <button className={`cdp-tab${activeTab === 'forms' ? ' active' : ''}`} onClick={() => this.switchTab('forms')}>
          Forms
        </button>
        {/* ?tab=bailey (the bell's "needs a reply") opens Messages on Bailey's chats */}
        <button className={`cdp-tab${activeTab === 'messages' || activeTab === 'bailey' ? ' active' : ''}`} onClick={() => this.switchTab('messages')}>
          Messages
        </button>
        {/* Bailey's chats with this client live in Messages now (its Bailey filter). */}
        {CLIENT_PHOTOS_ENABLED && (
          <button className={`cdp-tab${activeTab === 'photos' ? ' active' : ''}`} onClick={() => this.switchTab('photos')}>
            Photos
          </button>
        )}
      </div>
    );
  }

  renderPhotos() {
    const client = this.props.clientDetail?.clientDetail;
    const clientName = [client?.firstName, client?.lastName].filter(Boolean).join(' ') || client?.name || '';
    return (
      <ClientPhotosTab clientId={this.props.clientId} clientName={clientName} />
    );
  }

  // Overview: a small "recent bookings" preview (~5 rows) from the summary
  // payload's recentBookings, with a jump into the full Bookings tab. The whole
  // history is NOT loaded here — that's the paginated Bookings tab's job.
  renderRecentBookings() {
    const recent = this.state.recentBookings || [];
    if (recent.length === 0) return null;
    return (
      <div className="cdp-info-group">
        <p className="cdp-info-group-title">Recent bookings</p>
        <div className="cdp-booking-subsection">
          {recent.slice(0, 5).map((b, i) => this.renderBookingRow(b, 'r' + i, false))}
        </div>
        <button className="cdp-view-all" onClick={() => this.switchTab('bookings')}>
          View all in Bookings
        </button>
      </div>
    );
  }

  // Overview tab
  renderOverview() {
    const client = this.props.clientDetail?.clientDetail;
    return (
      <div className="cdp-tab-content">
        <div className="cdp-overview-action">
          <button className="cdp-action-btn" onClick={this.openNewBookingPanel}>
            New Booking
          </button>
        </div>

        {this.state.magicLinkMessage && (
          <div style={{
            padding: '10px 14px', margin: '0 0 12px', borderRadius: 8, fontSize: 14,
            background: this.state.magicLinkMessage.startsWith('Error') ? '#fdecea' : '#e7f5ee',
            color: this.state.magicLinkMessage.startsWith('Error') ? '#a8071a' : '#0f5132',
            position: 'relative',
          }}>
            <div style={{ paddingRight: 20 }}>{this.state.magicLinkMessage}</div>
            {this.state.magicLinkUrl && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                <input readOnly value={this.state.magicLinkUrl}
                  ref={this.magicLinkInputRef}
                  onFocus={(e) => e.target.select()}
                  onClick={(e) => e.target.select()}
                  style={{ flex: 1, minWidth: 0, fontSize: 12, padding: '6px 8px', borderRadius: 6, border: '1px solid #cfe3d8', background: '#fff', color: '#333' }} />
                <button type="button" onClick={this.copyMagicLink}
                  style={{ padding: '6px 14px', borderRadius: 6, border: 'none', background: '#0f5132', color: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                  {this.state.magicLinkCopied ? 'Copied ✓' : 'Copy link'}
                </button>
              </div>
            )}
            <button type="button" aria-label="Dismiss"
              onClick={() => this.setState({ magicLinkMessage: '', magicLinkUrl: '' })}
              style={{ position: 'absolute', top: 8, right: 10, border: 'none', background: 'none', color: 'inherit', fontSize: 14, cursor: 'pointer', lineHeight: 1 }}>
              ✕
            </button>
          </div>
        )}

        {this.state.mergeSuggestion && (
          <div style={{
            background: '#e7f5ff', border: '1px solid #74c0fc', color: '#0b3d56',
            padding: '12px 14px', borderRadius: 8, margin: '0 0 12px', fontSize: 14,
          }}>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>This email matches an existing Beu account</div>
            <div style={{ marginBottom: 10 }}>
              {this.state.mergeSuggestion.message} {this.state.mergeSuggestion.matchingUserName ? `(${this.state.mergeSuggestion.matchingUserName})` : ''}
            </div>
            <button type="button" onClick={() => this.setState({ mergeView: true })}
              style={{ padding: '7px 14px', border: 'none', background: '#007EA0', color: '#fff', borderRadius: 6, fontWeight: 600, marginRight: 8, fontSize: 13, cursor: 'pointer' }}>
              Link records
            </button>
            <button type="button" onClick={() => this.setState({ mergeSuggestion: null })}
              style={{ padding: '7px 14px', border: '1px solid #ccc', background: '#fff', color: '#333', borderRadius: 6, fontSize: 13, cursor: 'pointer' }}>
              Not now
            </button>
          </div>
        )}

        <div className="cdp-info-group">
          <p className="cdp-info-group-title">Contact</p>
          {this.renderPendingUpdateFor('name')}
          {this.checkEmail(client?.email) && (
            <div className="cdp-info-row">
              <span className="cdp-info-label">Email</span>
              <span className="cdp-info-value">{client.email}</span>
            </div>
          )}
          {this.renderPendingUpdateFor('email')}
          <div className="cdp-info-row">
            <span className="cdp-info-label">Phone</span>
            <span className="cdp-info-value">{client?.phoneNumber || '-'}</span>
          </div>
          {this.renderPendingUpdateFor('phoneNumber')}
        </div>

        <div className="cdp-info-group">
          <p className="cdp-info-group-title">Details</p>
          <div className="cdp-info-row">
            <span className="cdp-info-label">Date of Birth</span>
            <span className="cdp-info-value">{client?.dob ? moment(client.dob, 'DD-MM-YYYY').format('DD MMM YYYY') : '-'}</span>
          </div>
          {this.renderPendingUpdateFor('dob')}
          <div className="cdp-info-row">
            <span className="cdp-info-label">Client Since</span>
            <span className="cdp-info-value">{client?.createdAt ? moment(client.createdAt).format('DD MMM YYYY') : '-'}</span>
          </div>
          {client?.clientOwnerName && (
            <div className="cdp-info-row">
              <span className="cdp-info-label">Owner</span>
              <span className="cdp-info-value">{client.clientOwnerName}</span>
            </div>
          )}
        </div>

        {this.renderRecentBookings()}

        <div className="cdp-info-group">
          <p className="cdp-info-group-title">Marketing permission</p>
          <div className="cdp-info-row" style={{ alignItems: 'center' }}>
            <span className="cdp-info-label">Email marketing</span>
            {this.renderConsentToggle('emailMarketingConsent')}
          </div>
          <div className="cdp-info-row" style={{ alignItems: 'center' }}>
            <span className="cdp-info-label">SMS marketing</span>
            {this.renderConsentToggle('smsMarketingConsent')}
          </div>
          <p style={{ fontSize: 12, color: '#8E8E93', lineHeight: 1.5, margin: '8px 0 0' }}>
            Clients receive campaigns by default. Switch off to stop marketing to this client.
          </p>
        </div>
      </div>
    );
  }

  // Open a booking detail as a nested slide-out on top of the
  // current client panel. No navigation, easy back.
  handleOpenBooking = (booking) => {
    if (!booking?._id) return;
    // bookingSlot is [start, end] in minutes from midnight, same unit the
    // diary's normalizeData uses for startMinutes / endMinutes. Pass the real
    // values so the panel header doesn't show 00:00 - 00:00 / 0 min while the
    // detail call is in flight (and as the fallback if it never carries a slot).
    this.setState({
      openBookingEvent: {
        type: 'booking',
        bookingId: booking._id,
        date: booking.bookingDate,
        startMinutes: booking.bookingSlot?.[0] ?? 0,
        endMinutes: booking.bookingSlot?.[1] ?? 0,
        // Online (1) / in-salon (0) from the list payload. The panel prefers the
        // detail response when it carries the flag, and uses this otherwise.
        isOnlineBooking: booking.isOnlineBooking,
        title: '',
        clientName: '',
      },
    });
  }

  // Bookings tab
  hasCardAttached = (booking) => {
    return booking?.stripePaymentMethodId && booking.stripePaymentMethodId !== '';
  }

  renderBookingRow(booking, idx, isUpcoming) {
    // Online booking the client started but never secured (deposit unpaid /
    // card not captured). BE flags it; fall back to raw fields for older payloads.
    const isUnsecured = booking.abandonedCheckout === true || (
      booking.isOnlineBooking === 1 &&
      booking.bookingStatus !== 3 && booking.bookingStatus !== 6 &&
      (
        (booking.isDeposit === 1 && booking.isDepositPay !== 1) ||
        (booking.isCardCapture === 1 && !this.hasCardAttached(booking))
      )
    );
    // Fresh ones might still get finished, so show "Not booked yet"; once they're
    // older than the grace window they're realistically gone -> "Abandoned".
    const ABANDONED_AFTER_HRS = 24;
    const unsecuredCreatedAt = booking.createdAt || booking.createdTime;
    const unsecuredAgeHrs = unsecuredCreatedAt
      ? (Date.now() - new Date(unsecuredCreatedAt).getTime()) / 3600000
      : 0;
    const isAbandoned = isUnsecured; // muted styling applies to both states
    const unsecuredLabel = (isUnsecured && unsecuredAgeHrs >= ABANDONED_AFTER_HRS)
      ? 'Abandoned'
      : 'Not booked yet';
    const statusClass = this.getBookingStatusClass(booking);
    const statusPill = this.getBookingStatusPill(booking);
    const services = this.getServiceName(booking);
    const time = booking.isCheckout ? 'Checkout' :
      this.getSlotTime(booking.bookingSlot[0]) + ' - ' + this.getSlotTime(booking.bookingSlot[1]);
    const date = moment(booking.bookingDate).format('DD MMM YYYY');
    const hasCard = isUpcoming && this.hasCardAttached(booking);
    const bookingPhotos = (this.props.photosByBookingId && this.props.photosByBookingId[booking._id]) || [];

    const openable = !isAbandoned && this.canOpenBooking(booking);
    return (
      <div
        key={idx}
        className={'cdp-booking' + (isAbandoned ? ' cdp-booking--abandoned' : (openable ? ' cdp-booking--clickable' : ''))}
        onClick={openable ? () => this.handleOpenBooking(booking) : undefined}
        role={openable ? 'button' : undefined}
        tabIndex={openable ? 0 : undefined}
        title={!isAbandoned && !openable ? "In a colleague's diary you can't see" : undefined}
      >
        <div className={'cdp-booking-dot ' + (isAbandoned ? 'abandoned' : statusClass)} />
        <div className="cdp-booking-body">
          <p className="cdp-booking-service">
            <span className="cdp-booking-service-name">{services}</span>
            {isAbandoned ? (
              <span className="cdp-status-pill cdp-status-pill--abandoned">{unsecuredLabel}</span>
            ) : (
              <span className={`cdp-status-pill ${statusPill.css}`}>{statusPill.label}</span>
            )}
            {!isAbandoned && <RefundBadge sale={booking} small />}
          </p>
          <p className="cdp-booking-meta">
            {date} &middot; {time}
            {hasCard && (
              <span className="cdp-card-badge">
                <svg width="14" height="11" viewBox="0 0 30 24" fill="currentColor">
                  <path d="M30,6H6A2.977,2.977,0,0,0,3.015,9L3,27a2.99,2.99,0,0,0,3,3H30a2.99,2.99,0,0,0,3-3V9A2.99,2.99,0,0,0,30,6Zm0,21H6V18H30Zm0-15H6V9H30Z" transform="translate(-3 -6)"/>
                </svg>
                Card
              </span>
            )}
          </p>
          {bookingPhotos.length > 0 && (
            <div className="cdp-booking-photos">
              {bookingPhotos.slice(0, 5).map((p) => (
                <button
                  key={p.id}
                  type="button"
                  className="cdp-booking-photo"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.switchTab('photos');
                  }}
                  aria-label="View photo"
                >
                  <img src={p.thumbUrl || p.url} alt="" />
                </button>
              ))}
              {bookingPhotos.length > 5 && (
                <span className="cdp-booking-photos-more">+{bookingPhotos.length - 5}</span>
              )}
            </div>
          )}
        </div>
        <div className="cdp-booking-right">
          <span className="cdp-booking-price">&pound;{this.getTotalPrice(booking).toFixed(2)}</span>
          {isUpcoming && !isUnsecured && (
            <button
              className={'cdp-resend-btn' + (this.state.resentBookingIds.includes(booking._id) ? ' sent' : '')}
              onClick={(e) => this.handleResendConfirmation(booking._id, e)}
              disabled={this.state.resendingBookingId === booking._id || this.state.resentBookingIds.includes(booking._id)}
            >
              {this.state.resentBookingIds.includes(booking._id) ? (
                <>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
                  Sent
                </>
              ) : this.state.resendingBookingId === booking._id ? (
                'Sending...'
              ) : (
                <>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" /></svg>
                  Email Confirm Card
                </>
              )}
            </button>
          )}
        </div>
      </div>
    );
  }

  // ── Bookings tab: paginated past + upcoming ───────────────────
  // On first open we fetch page 1 of BOTH past and upcoming so the sub-tab
  // toggle switches instantly; each side then paginates independently via
  // "Load more". Repointed off the old full clientDetail arrays onto the
  // dedicated client/bookings endpoint.
  loadBookings = () => {
    this.setState({ bookingsLoaded: true, pastBookingsLoading: true, upcomingBookingsLoading: true });
    const clientId = this.props.clientId;
    marketingBackend.clientBookings(clientId, 'past', 1, this.PAGE_SIZE)
      .then((data) => this.setState({
        pastBookings: (data && data.bookings) || [],
        pastBookingsPage: (data && data.page) || 1,
        pastBookingsHasMore: !!(data && data.hasMore),
        pastBookingsLoading: false,
      }))
      .catch(() => this.setState({ pastBookings: [], pastBookingsLoading: false, pastBookingsError: true, pastBookingsHasMore: false }));
    marketingBackend.clientBookings(clientId, 'upcoming', 1, this.PAGE_SIZE)
      .then((data) => this.setState({
        upcomingBookings: (data && data.bookings) || [],
        upcomingBookingsPage: (data && data.page) || 1,
        upcomingBookingsHasMore: !!(data && data.hasMore),
        upcomingBookingsLoading: false,
      }))
      .catch(() => this.setState({ upcomingBookings: [], upcomingBookingsLoading: false, upcomingBookingsError: true, upcomingBookingsHasMore: false }));
  };

  loadMoreBookings = (type) => {
    const isPast = type === 'past';
    const loadingMoreKey = isPast ? 'pastBookingsLoadingMore' : 'upcomingBookingsLoadingMore';
    const hasMoreKey = isPast ? 'pastBookingsHasMore' : 'upcomingBookingsHasMore';
    const pageKey = isPast ? 'pastBookingsPage' : 'upcomingBookingsPage';
    const listKey = isPast ? 'pastBookings' : 'upcomingBookings';
    if (this.state[loadingMoreKey] || !this.state[hasMoreKey]) return;
    const nextPage = (this.state[pageKey] || 1) + 1;
    this.setState({ [loadingMoreKey]: true });
    marketingBackend.clientBookings(this.props.clientId, type, nextPage, this.PAGE_SIZE)
      .then((data) => this.setState((s) => ({
        [listKey]: [...s[listKey], ...((data && data.bookings) || [])],
        [pageKey]: (data && data.page) || nextPage,
        [hasMoreKey]: !!(data && data.hasMore),
        [loadingMoreKey]: false,
      })))
      .catch(() => this.setState({ [loadingMoreKey]: false }));
  };

  // ── Sales tab: paginated products + vouchers ──────────────────
  loadSales = () => {
    this.setState({ salesLoaded: true, salesLoading: true });
    marketingBackend.clientSales(this.props.clientId, 1, this.PAGE_SIZE)
      .then((data) => this.setState({
        salesItems: (data && data.sales) || [],
        salesPage: (data && data.page) || 1,
        salesHasMore: !!(data && data.hasMore),
        salesLoading: false,
      }))
      .catch(() => this.setState({ salesItems: [], salesLoading: false, salesError: true, salesHasMore: false }));
  };

  loadMoreSales = () => {
    if (this.state.salesLoadingMore || !this.state.salesHasMore) return;
    const nextPage = (this.state.salesPage || 1) + 1;
    this.setState({ salesLoadingMore: true });
    marketingBackend.clientSales(this.props.clientId, nextPage, this.PAGE_SIZE)
      .then((data) => this.setState((s) => ({
        salesItems: [...s.salesItems, ...((data && data.sales) || [])],
        salesPage: (data && data.page) || nextPage,
        salesHasMore: !!(data && data.hasMore),
        salesLoadingMore: false,
      })))
      .catch(() => this.setState({ salesLoadingMore: false }));
  };

  // Shared "Load more" affordance — one visual language across every list tab.
  renderLoadMore(hasMore, loadingMore, onClick) {
    if (!hasMore) return null;
    return (
      <button
        type="button"
        className="cdp-load-more"
        onClick={onClick}
        disabled={loadingMore}
      >
        {loadingMore ? 'Loading…' : 'Load more'}
      </button>
    );
  }

  renderBookings() {
    const {
      bookingsSubTab, pastBookings, upcomingBookings,
      pastBookingsLoading, upcomingBookingsLoading, bookingsLoaded,
      pastBookingsError, upcomingBookingsError,
    } = this.state;

    const isPast = bookingsSubTab === 'past';
    const list = isPast ? pastBookings : upcomingBookings;
    const loading = isPast ? pastBookingsLoading : upcomingBookingsLoading;
    const error = isPast ? pastBookingsError : upcomingBookingsError;
    const hasMore = isPast ? this.state.pastBookingsHasMore : this.state.upcomingBookingsHasMore;
    const loadingMore = isPast ? this.state.pastBookingsLoadingMore : this.state.upcomingBookingsLoadingMore;

    const subTabBtn = (key, label) => (
      <button
        type="button"
        onClick={() => this.setState({ bookingsSubTab: key })}
        style={{
          flex: 1, padding: '8px 10px', border: 'none', borderRadius: 8, cursor: 'pointer',
          fontFamily: 'inherit', fontSize: 13, fontWeight: 700,
          color: bookingsSubTab === key ? '#1A1A1E' : '#8E8E93',
          background: bookingsSubTab === key ? '#fff' : 'transparent',
          boxShadow: bookingsSubTab === key ? '0 1px 3px rgba(0,0,0,0.08)' : 'none',
          transition: 'background 0.15s, color 0.15s',
        }}
      >
        {label}
      </button>
    );

    return (
      <div className="cdp-tab-content">
        <div style={{ display: 'flex', gap: 4, padding: 4, background: '#F2F2F7', borderRadius: 10, marginBottom: 8 }}>
          {subTabBtn('past', 'Past')}
          {subTabBtn('upcoming', 'Upcoming')}
        </div>
        {(loading && list.length === 0) || !bookingsLoaded ? (
          <p className="cdp-empty">Loading bookings...</p>
        ) : error && list.length === 0 ? (
          <p className="cdp-empty">Couldn&rsquo;t load bookings</p>
        ) : list.length === 0 ? (
          <p className="cdp-empty">{isPast ? 'No past bookings' : 'No upcoming bookings'}</p>
        ) : (
          <div className="cdp-booking-subsection">
            {list.map((b, i) => this.renderBookingRow(b, (isPast ? 'p' : 'u') + i, !isPast))}
            {this.renderLoadMore(hasMore, loadingMore, () => this.loadMoreBookings(isPast ? 'past' : 'upcoming'))}
          </div>
        )}
      </div>
    );
  }

  // Notes tab
  renderNotes() {
    const client = this.props.clientDetail?.clientDetail;
    const hasNote = !!client?.note;

    return (
      <div className={'cdp-tab-content' + (this.state.editingNote ? ' cdp-tab-content--editing' : '')}>
        {this.state.editingNote ? (
          <>
            <textarea
              className="cdp-notes-textarea"
              value={this.state.noteText}
              onChange={(e) => this.setState({ noteText: e.target.value })}
              placeholder="Add notes about this client..."
              disabled={this.state.savingNote}
              autoFocus
            />
            <div className="cdp-notes-actions">
              <button className="cdp-btn-cancel" onClick={this.handleCancelNote} disabled={this.state.savingNote}>Cancel</button>
              <button className="cdp-btn-save" onClick={this.handleSaveNote} disabled={this.state.savingNote}>
                {this.state.savingNote ? 'Saving...' : 'Save'}
              </button>
            </div>
          </>
        ) : hasNote ? (
          <div className="cdp-notes-header">
            <p className="cdp-notes-text">{client.note}</p>
            {this.canClientAction('canEdit') && (
              <button className="cdp-notes-edit-btn" onClick={this.handleEditNote}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
              </button>
            )}
          </div>
        ) : (
          <>
            <p className="cdp-notes-empty">No notes yet</p>
            {this.canClientAction('canEdit') && (
              <button className="cdp-add-note-btn" onClick={this.handleEditNote}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
                </svg>
                Add a note
              </button>
            )}
          </>
        )}
      </div>
    );
  }

  // Sales tab — totals come from the cheap summary payload; the itemised list
  // is lazy-loaded (page 1 on tab open) and paginated via "Load more". The
  // endpoint returns a unified sales feed; each row carries a `type`
  // ('product' | 'voucher') so we render products and vouchers in one list
  // rather than pulling the whole history into two arrays up front.
  renderSaleRow(sale, i) {
    const isVoucher = sale.type === 'voucher';
    const name = isVoucher
      ? (sale.voucherName || 'Gift Voucher')
      : (sale.productName || 'Product');
    const qty = sale.quantity || 1;
    const amount = isVoucher
      ? (sale.amount || 0)
      : ((sale.price || 0) * qty);
    return (
      <div key={sale._id || i} className="cdp-purchase">
        <div>
          <p className="cdp-purchase-name">{name}</p>
          <p className="cdp-purchase-meta">
            {sale.purchaseDate ? moment(sale.purchaseDate).format('DD MMM YYYY') : ''}
            {!isVoucher && qty ? ` · Qty: ${qty}` : ''}
          </p>
        </div>
        <span className="cdp-purchase-price">&pound;{amount.toFixed(2)}</span>
      </div>
    );
  }

  renderSales() {
    const client = this.props.clientDetail?.clientDetail;
    const { salesItems, salesLoading, salesLoaded, salesError } = this.state;

    return (
      <div className="cdp-tab-content">
        {client?.salesSummary && (
          <div className="cdp-sales-summary">
            <div className="cdp-sales-card">
              <p className="cdp-sales-card-value">&pound;{client.salesSummary.totalProductSales}</p>
              <p className="cdp-sales-card-label">Products</p>
            </div>
            <div className="cdp-sales-card">
              <p className="cdp-sales-card-value">&pound;{client.salesSummary.totalVoucherSales}</p>
              <p className="cdp-sales-card-label">Vouchers</p>
            </div>
          </div>
        )}

        {(salesLoading && salesItems.length === 0) || !salesLoaded ? (
          <p className="cdp-empty">Loading purchases...</p>
        ) : salesError && salesItems.length === 0 ? (
          <p className="cdp-empty">Couldn&rsquo;t load purchases</p>
        ) : salesItems.length === 0 ? (
          <p className="cdp-empty">No purchases yet</p>
        ) : (
          <div className="cdp-sales-subsection">
            {salesItems.map((s, i) => this.renderSaleRow(s, i))}
            {this.renderLoadMore(this.state.salesHasMore, this.state.salesLoadingMore, this.loadMoreSales)}
          </div>
        )}
      </div>
    );
  }

  // The salon's own loyalty scheme (cached by loyaltyStore). The client's
  // per-client progress needs a staff-scoped loyalty endpoint that doesn't
  // exist yet, so progress is shown as pending with a sample preview.
  getSalonLoyaltyScheme() {
    // Once the wallet tab has hydrated from the backend, trust that; before
    // then fall back to the local cache so a warm cache shows instantly.
    if (this.state.loyaltySchemeLoaded) return this.state.loyaltyScheme || null;
    try { return loadLoyaltyScheme(loyaltyOwnerId()); } catch (e) { return null; }
  }

  // Fetch this client's REAL loyalty card at the salon (staff endpoint), so the
  // wallet shows actual stamps/points rather than a sample. Resolves to null on
  // any error → honest empty state.
  loadLoyaltyCard = () => {
    const clientUserId = this.props.clientId;
    if (!clientUserId || this.state.loyaltyCardLoading) return;
    this.setState({ loyaltyCardLoading: true });
    // Hydrate the salon scheme from the backend so the wallet reflects real
    // state, not a cold local cache (which would misread as "no scheme").
    hydrateLoyalty(loyaltyOwnerId())
      .then(({ scheme }) => this.setState({ loyaltyScheme: scheme || null, loyaltySchemeLoaded: true }))
      .catch(() => this.setState({ loyaltySchemeLoaded: true }));
    marketingBackend.loyaltyClientCards(clientUserId)
      .then((res) => {
        const cards = (res && res.cards) || [];
        this.setState({ loyaltyClientCard: cards[0] || null, loyaltyCardLoaded: true, loyaltyCardLoading: false });
      })
      .catch(() => this.setState({ loyaltyClientCard: null, loyaltyCardLoaded: true, loyaltyCardLoading: false }));
  };

  // Fetch the earn/redeem/reverse audit trail for the displayed card on demand.
  // Page 1 on first expand; "Load more" appends subsequent pages.
  loadLoyaltyHistory = () => {
    const clientUserId = this.props.clientId;
    const card = this.state.loyaltyClientCard;
    if (this.state.showLoyaltyHistory) { this.setState({ showLoyaltyHistory: false }); return; }
    this.setState({ showLoyaltyHistory: true });
    if (this.state.loyaltyHistoryLoaded || this.state.loyaltyHistoryLoading || !clientUserId) return;
    this.setState({ loyaltyHistoryLoading: true });
    marketingBackend.loyaltyClientHistory(clientUserId, card && card.schemeId, 1, this.PAGE_SIZE)
      .then((res) => this.setState({
        loyaltyHistory: (res && res.history) || [],
        loyaltyHistoryPage: (res && res.page) || 1,
        loyaltyHistoryHasMore: !!(res && res.hasMore),
        loyaltyHistoryLoaded: true,
        loyaltyHistoryLoading: false,
      }))
      .catch(() => this.setState({ loyaltyHistory: [], loyaltyHistoryLoaded: true, loyaltyHistoryLoading: false, loyaltyHistoryHasMore: false }));
  };

  loadMoreLoyaltyHistory = () => {
    if (this.state.loyaltyHistoryLoadingMore || !this.state.loyaltyHistoryHasMore) return;
    const card = this.state.loyaltyClientCard;
    const nextPage = (this.state.loyaltyHistoryPage || 1) + 1;
    this.setState({ loyaltyHistoryLoadingMore: true });
    marketingBackend.loyaltyClientHistory(this.props.clientId, card && card.schemeId, nextPage, this.PAGE_SIZE)
      .then((res) => this.setState((s) => ({
        loyaltyHistory: [...s.loyaltyHistory, ...((res && res.history) || [])],
        loyaltyHistoryPage: (res && res.page) || nextPage,
        loyaltyHistoryHasMore: !!(res && res.hasMore),
        loyaltyHistoryLoadingMore: false,
      })))
      .catch(() => this.setState({ loyaltyHistoryLoadingMore: false }));
  };

  // Wallet tab: the client's gift cards (real, from purchases) and their real
  // loyalty card with this salon (scheme + per-client progress both live).
  renderWallet() {
    const client = this.props.clientDetail?.clientDetail;
    const clientName = [client?.firstName, client?.lastName].filter(Boolean).join(' ') || client?.name || 'This client';
    const vouchers = client?.voucherPurchases || [];
    const scheme = this.getSalonLoyaltyScheme();
    const demo = this.state.loyaltyDemo;

    // Sample progress for the preview: half-filled stamps / mid points.
    const sampleState = scheme
      ? (scheme.mode === 'points'
        ? { balance: Math.round((scheme.pointsTarget || 500) * 0.6) }
        : { filled: Math.max(1, Math.ceil((scheme.stampsRequired || 6) / 2)) })
      : {};

    // The client's REAL card (from the staff endpoint): filled=cumulative
    // stamps, balance=points. Null until loaded / no card yet.
    const card = this.state.loyaltyClientCard;
    const rewardsAvailable = (card && card.rewardsAvailable) || 0;
    const stampsReq = (scheme && scheme.stampsRequired) || 6;
    // A full card with an unclaimed reward reads as FULL until redeemed
    // (matches the client wallet); otherwise show the current-cycle progress.
    const displayFilled = card ? (rewardsAvailable > 0 ? stampsReq : ((card.filled || 0) % stampsReq)) : 0;
    const realState = card ? { filled: displayFilled, balance: card.balance || 0 } : { filled: 0, balance: 0 };
    const hasProgress = !!card && (displayFilled > 0 || (card.balance || 0) > 0 || rewardsAvailable > 0);
    const cardLoading = this.state.loyaltyCardLoading && !this.state.loyaltyCardLoaded;
    const loyaltyEventLabel = (h) => {
      switch (h.type) {
        case 'earn': return (h.value > 1) ? `Earned ${h.value} points` : 'Earned a stamp';
        case 'redeem': return 'Redeemed a reward';
        case 'reverse': return 'Stamp reversed (refund)';
        case 'redeem-reverse': return 'Reward re-credited';
        default: return h.type;
      }
    };

    return (
      <div className="cdp-tab-content">
        {/* Loyalty (card first — it's the visual hero of the tab) */}
        <div className="cdp-sales-subsection">
          <p className="cdp-sales-subsection-title">Loyalty</p>
          {!scheme ? (
            !this.state.loyaltySchemeLoaded ? (
              <p className="cdp-empty" style={{ padding: '18px 0' }}>Loading…</p>
            ) : (
              <div style={{ padding: '20px 0 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14, textAlign: 'center' }}>
                <p style={{ margin: 0, color: '#8E8E93', fontSize: 13.5, lineHeight: 1.5, maxWidth: 300 }}>
                  No loyalty scheme yet. Reward repeat clients with a card they collect.
                </p>
                <button
                  type="button"
                  onClick={() => this.navigateAway('/marketing-loyalty')}
                  style={{ padding: '10px 20px', border: 'none', borderRadius: 10, background: '#29282D', color: '#fff', fontSize: 13.5, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}
                >
                  Set up loyalty
                </button>
              </div>
            )
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14, paddingTop: 6 }}>
              <LoyaltyCard
                design={scheme.design}
                scheme={scheme}
                state={demo ? sampleState : realState}
                salonName={localStorage.getItem('salonName') || 'Your salon'}
                width={300}
              />
              {demo ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '10px 14px', background: 'rgba(0,126,160,0.08)', border: '1px solid rgba(0,126,160,0.2)', borderRadius: 12 }}>
                  <span style={{ fontSize: 12, fontWeight: 600, color: '#007EA0', flex: 1 }}>Sample progress, not this client's real data.</span>
                  <button type="button" onClick={() => this.setState({ loyaltyDemo: false })} style={{ border: 'none', background: 'none', fontSize: 12, fontWeight: 700, color: '#007EA0', cursor: 'pointer', fontFamily: 'inherit', textDecoration: 'underline' }}>Exit</button>
                </div>
              ) : cardLoading ? (
                <p style={{ fontSize: 12.5, color: '#8E8E93', margin: '4px 0' }}>Loading progress&hellip;</p>
              ) : hasProgress ? (
                <div style={{ textAlign: 'center' }}>
                  <p style={{ fontSize: 13, fontWeight: 700, color: '#1A1A1E', margin: '0 0 2px' }}>
                    {card.mode === 'points'
                      ? `${card.balance || 0} points`
                      : `${displayFilled} of ${stampsReq} stamps`}
                  </p>
                  {rewardsAvailable > 0 && (
                    <p style={{ fontSize: 12.5, fontWeight: 700, color: '#007EA0', margin: 0 }}>
                      {rewardsAvailable} reward{rewardsAvailable === 1 ? '' : 's'} ready to redeem
                    </p>
                  )}
                  {card.mode !== 'points' && (card.timesCompleted || 0) > 0 && (
                    <p style={{ fontSize: 12, color: '#8E8E93', margin: '4px 0 0' }}>
                      Card maxed {card.timesCompleted} time{card.timesCompleted === 1 ? '' : 's'}
                      {(card.redeemedRewards || 0) > 0 ? ` · ${card.redeemedRewards} claimed` : ''}
                    </p>
                  )}
                  <button
                    type="button"
                    onClick={this.loadLoyaltyHistory}
                    style={{ marginTop: 8, border: 'none', background: 'none', fontSize: 12, fontWeight: 700, color: '#007EA0', cursor: 'pointer', fontFamily: 'inherit', textDecoration: 'underline' }}
                  >
                    {this.state.showLoyaltyHistory ? 'Hide history' : 'View history'}
                  </button>
                  {this.state.showLoyaltyHistory && (
                    <div style={{ marginTop: 10, textAlign: 'left', width: '100%', maxWidth: 300, marginLeft: 'auto', marginRight: 'auto' }}>
                      {this.state.loyaltyHistoryLoading ? (
                        <p style={{ fontSize: 12, color: '#8E8E93', textAlign: 'center', margin: 0 }}>Loading history&hellip;</p>
                      ) : (this.state.loyaltyHistory && this.state.loyaltyHistory.length) ? (
                        <>
                          {this.state.loyaltyHistory.map((h, i) => (
                            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: 10, padding: '7px 0', borderBottom: '1px solid #F2F2F7' }}>
                              <span style={{ fontSize: 12.5, color: '#1A1A1E' }}>{loyaltyEventLabel(h)}</span>
                              <span style={{ fontSize: 12, color: '#8E8E93', flexShrink: 0 }}>
                                {h.at ? new Date(h.at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : ''}
                              </span>
                            </div>
                          ))}
                          {this.state.loyaltyHistoryHasMore && (
                            <button
                              type="button"
                              onClick={this.loadMoreLoyaltyHistory}
                              disabled={this.state.loyaltyHistoryLoadingMore}
                              style={{ display: 'block', margin: '10px auto 0', border: 'none', background: 'none', fontSize: 12, fontWeight: 700, color: '#007EA0', cursor: 'pointer', fontFamily: 'inherit', textDecoration: 'underline' }}
                            >
                              {this.state.loyaltyHistoryLoadingMore ? 'Loading…' : 'Load more'}
                            </button>
                          )}
                        </>
                      ) : (
                        <p style={{ fontSize: 12, color: '#8E8E93', textAlign: 'center', margin: 0 }}>No history yet.</p>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div style={{ textAlign: 'center' }}>
                  <p style={{ fontSize: 12.5, color: '#8E8E93', lineHeight: 1.55, margin: '0 0 12px', maxWidth: 300 }}>
                    No stamps yet. {clientName} earns on this card when they pay for a completed visit.
                  </p>
                  <button type="button" onClick={() => this.setState({ loyaltyDemo: true })} style={{ padding: '8px 16px', borderRadius: 100, border: '1px solid #007EA0', background: '#fff', fontSize: 12.5, fontWeight: 700, color: '#007EA0', cursor: 'pointer', fontFamily: 'inherit' }}>
                    Preview with sample data
                  </button>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Gift cards */}
        <div className="cdp-sales-subsection" style={{ marginTop: 24 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 12, marginBottom: vouchers.length ? 4 : 0 }}>
            <p className="cdp-sales-subsection-title" style={{ margin: 0 }}>Gift cards</p>
            {vouchers.length > 0 && (
              <span style={{ fontSize: 12.5, fontWeight: 700, color: '#1A1A1E', flexShrink: 0 }}>
                &pound;{vouchers.reduce((s, v) => s + (v.amount || 0), 0).toFixed(2)} · {vouchers.length} card{vouchers.length === 1 ? '' : 's'}
              </span>
            )}
          </div>
          {vouchers.length ? (
            <>
              {vouchers.slice(0, this.state.giftCardsExpanded ? vouchers.length : 4).map((v, i) => (
                <div key={i} className="cdp-purchase">
                  <div>
                    <p className="cdp-purchase-name">{v.voucherName || 'Gift card'}</p>
                    <p className="cdp-purchase-meta">{v.purchaseDate ? moment(v.purchaseDate).format('DD MMM YYYY') : ''}</p>
                  </div>
                  <span className="cdp-purchase-price">&pound;{v.amount?.toFixed(2) || '0.00'}</span>
                </div>
              ))}
              {vouchers.length > 4 && (
                <button
                  type="button"
                  onClick={() => this.setState((s) => ({ giftCardsExpanded: !s.giftCardsExpanded }))}
                  style={{ marginTop: 10, border: 'none', background: 'none', padding: 0, fontSize: 12.5, fontWeight: 700, color: '#007EA0', cursor: 'pointer', fontFamily: 'inherit' }}
                >
                  {this.state.giftCardsExpanded ? 'Show less' : `Show all ${vouchers.length}`}
                </button>
              )}
            </>
          ) : (
            <p className="cdp-empty" style={{ padding: '18px 0' }}>No gift cards on this account</p>
          )}
        </div>
      </div>
    );
  }

  // ── Message tab (nested sub-tabs) ─────────────────────────────
  // Sub-tab A: marketing messages this client has received (campaigns +
  // automations). Sourced from client/marketing-messages; the row renderer
  // reads name/subject/channel/sentAt/status, so we map the delivery
  // timestamps (opened/clicked/bounced) into a single derived status.
  // Map a raw marketing-message payload row into the shape the row renderer reads.
  mapMessage = (m) => ({
    id: m.campaignId,
    channel: m.channel,
    name: m.name,
    subject: m.subject,
    sentAt: m.sentAt,
    status: this.deriveMessageStatus(m),
  });

  loadClientMessages = () => {
    if (this.state.messagesLoaded || this.state.messagesLoading) return;
    this.setState({ messagesLoading: true, messagesError: false });
    marketingBackend.clientMarketingMessages(this.props.clientId, 1, this.PAGE_SIZE)
      .then((data) => {
        const raw = data && Array.isArray(data.messages) ? data.messages : [];
        this.setState({
          clientMessages: raw.map(this.mapMessage),
          messagesPage: (data && data.page) || 1,
          messagesHasMore: !!(data && data.hasMore),
          messagesLoaded: true,
          messagesLoading: false,
        });
      })
      .catch(() => this.setState({ clientMessages: [], messagesLoaded: true, messagesLoading: false, messagesError: true, messagesHasMore: false }));
  };

  loadMoreClientMessages = () => {
    if (this.state.messagesLoadingMore || !this.state.messagesHasMore) return;
    const nextPage = (this.state.messagesPage || 1) + 1;
    this.setState({ messagesLoadingMore: true });
    marketingBackend.clientMarketingMessages(this.props.clientId, nextPage, this.PAGE_SIZE)
      .then((data) => {
        const raw = data && Array.isArray(data.messages) ? data.messages : [];
        this.setState((s) => ({
          clientMessages: [...s.clientMessages, ...raw.map(this.mapMessage)],
          messagesPage: (data && data.page) || nextPage,
          messagesHasMore: !!(data && data.hasMore),
          messagesLoadingMore: false,
        }));
      })
      .catch(() => this.setState({ messagesLoadingMore: false }));
  };

  // Collapse the delivery/engagement timestamps into the single status the
  // message row + pill styling understands. Most→least engaged wins.
  deriveMessageStatus = (m) => {
    if (m.bouncedAt) return 'bounced';
    if (m.clickedAt) return 'clicked';
    if (m.openedAt) return 'opened';
    if (m.status) return String(m.status).toLowerCase();
    return 'delivered';
  };

  // Sub-tab B: the consent audit trail — current marketable state per channel,
  // plus a chronological timeline of consent changes and suppressions.
  loadConsentHistory = () => {
    if (this.state.consentLoaded || this.state.consentLoading) return;
    this.setState({ consentLoading: true, consentError: false });
    marketingBackend.clientConsentHistory(this.props.clientId, 1, this.PAGE_SIZE)
      .then((data) => {
        this.setState({
          consentHistory: Array.isArray(data?.history) ? data.history : [],
          consentCurrent: data?.current || null,
          consentSuppressions: Array.isArray(data?.suppressions) ? data.suppressions : [],
          consentPage: (data && data.page) || 1,
          consentHasMore: !!(data && data.hasMore),
          consentLoaded: true,
          consentLoading: false,
        });
      })
      .catch(() => this.setState({ consentHistory: [], consentCurrent: null, consentSuppressions: [], consentLoaded: true, consentLoading: false, consentError: true, consentHasMore: false }));
  };

  // "Load more" for the consent timeline. Current marketable state + page/hasMore
  // come from page 1; subsequent pages only extend the history + suppressions
  // arrays (the derived timeline in the render re-sorts the merged set).
  loadMoreConsentHistory = () => {
    if (this.state.consentLoadingMore || !this.state.consentHasMore) return;
    const nextPage = (this.state.consentPage || 1) + 1;
    this.setState({ consentLoadingMore: true });
    marketingBackend.clientConsentHistory(this.props.clientId, nextPage, this.PAGE_SIZE)
      .then((data) => {
        this.setState((s) => ({
          consentHistory: [...(s.consentHistory || []), ...(Array.isArray(data?.history) ? data.history : [])],
          consentSuppressions: [...(s.consentSuppressions || []), ...(Array.isArray(data?.suppressions) ? data.suppressions : [])],
          consentPage: (data && data.page) || nextPage,
          consentHasMore: !!(data && data.hasMore),
          consentLoadingMore: false,
        }));
      })
      .catch(() => this.setState({ consentLoadingMore: false }));
  };

  switchMessageSubTab = (sub) => {
    this.setState({ messageSubTab: sub }, () => {
      if (sub === 'messages') this.loadClientMessages();
      if (sub === 'consent') this.loadConsentHistory();
      if (sub === 'journeys') this.loadClientJourneys();
    });
  };

  // Journey membership. Answers "why did this client get that message?" and
  // "are they mid-journey right now?" — neither was visible anywhere before.
  loadClientJourneys = () => {
    const clientId = this.props.clientId || (this.props.client && this.props.client._id);
    if (!clientId || this.state.journeysLoading) return;
    this.setState({ journeysLoading: true });
    const { marketingBackend } = require('../marketing-v2/services/marketingBackend');
    marketingBackend.journeyRunsByClient(clientId)
      .then((res) => {
        const runs = (res && res.runs) || [];
        this.setState({ journeyRuns: runs, journeysLoading: false, journeysLoaded: true });
      })
      .catch(() => this.setState({ journeysLoading: false, journeysLoaded: true }));
  };

  renderJourneysSubTab() {
    const { journeyRuns, journeysLoading, journeysLoaded } = this.state;
    if (journeysLoading && !journeysLoaded) return <p className="cdp-empty">Loading journeys…</p>;
    if (!journeyRuns.length) return <p className="cdp-empty">This client isn't in any journeys.</p>;
    const badge = (status) => {
      const map = {
        active: { bg: 'rgba(0,126,160,0.10)', fg: '#007EA0', label: 'Active' },
        completed: { bg: 'rgba(52,199,89,0.12)', fg: '#248A3D', label: 'Completed' },
        exited: { bg: '#F2F2F7', fg: '#6B7280', label: 'Exited' },
        cancelled: { bg: '#FDECEA', fg: '#A8071A', label: 'Cancelled' },
      };
      const m = map[status] || map.exited;
      return (
        <span style={{ background: m.bg, color: m.fg, borderRadius: 12, padding: '2px 10px', fontSize: 12, fontWeight: 700 }}>
          {m.label}
        </span>
      );
    };
    const when = (d) => (d ? new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }) : null);
    return (
      <div>
        {journeyRuns.map((r) => (
          <div key={r.runId} style={{ border: '1px solid #ECECF0', borderRadius: 12, padding: 14, marginBottom: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, marginBottom: 6 }}>
              <strong style={{ fontSize: 14, color: '#29282D' }}>{r.journeyName}</strong>
              {badge(r.status)}
            </div>
            <div style={{ fontSize: 13, color: '#6B7280', lineHeight: 1.6 }}>
              {r.stepTotal ? <>Step {r.stepPosition} of {r.stepTotal}</> : 'No steps'}
              {r.messagesSent ? ` · ${r.messagesSent} message${r.messagesSent === 1 ? '' : 's'} sent` : ' · nothing sent yet'}
              {r.status === 'active' && !r.heldReason && r.wakeAt && <> · next {r.nextStepType || 'step'} {when(r.wakeAt)}</>}
              {r.status !== 'active' && r.statusReason && <> · {String(r.statusReason).replace(/_/g, ' ')}</>}
            </div>
            {r.heldReason && (
              <div style={{
                marginTop: 8, background: '#FFF8E6', border: '1px solid #F5D982', borderRadius: 8,
                padding: '7px 10px', fontSize: 12, color: '#7A5B00', lineHeight: 1.5
              }}>
                Waiting: {r.heldReason.indexOf('frequency cap') === 0
                  ? 'this client already had an automated message in the last 24h (one per day across all journeys)'
                  : r.heldReason}
                {r.wakeAt && <> · retries {when(r.wakeAt)}</>}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }

  // Human-friendly label for the consent-change `source` codes.
  consentSourceLabel = (source) => {
    switch (source) {
      case 'salon_ui': return 'salon';
      case 'bulk_tool': return 'bulk update';
      case 'unsubscribe_link': return 'unsubscribe link';
      case 'stop_reply': return 'STOP reply';
      case 'hard_bounce': return 'bounced';
      case 'spam_report': return 'spam report';
      case 'client': return 'client';
      default: return source || 'system';
    }
  };

  buildSampleMessages = () => {
    const at = (daysBack, hour, minute) => {
      const d = new Date(Date.now() - daysBack * 864e5);
      d.setHours(hour, minute, 0, 0);
      return d.toISOString();
    };
    return [
      { id: 'demo-1', channel: 'sms', name: 'Last-minute Saturday slots', sentAt: at(2, 10, 2), status: 'booked', source: 'Campaign' },
      { id: 'demo-2', channel: 'email', name: 'Spring Glow Sale', sentAt: at(5, 18, 30), status: 'clicked', source: 'Campaign' },
      { id: 'demo-3', channel: 'email', name: 'Appointment reminder', sentAt: at(9, 9, 0), status: 'opened', source: 'Automation' },
      { id: 'demo-4', channel: 'sms', name: 'Appointment reminder', sentAt: at(9, 9, 0), status: 'delivered', source: 'Automation' },
      { id: 'demo-5', channel: 'email', name: 'Gift Cards for Mother\u2019s Day', sentAt: at(16, 12, 15), status: 'opened', source: 'Campaign' },
      { id: 'demo-6', channel: 'email', name: 'Google review invite', sentAt: at(24, 17, 45), status: 'clicked', source: 'Review booster' },
      { id: 'demo-7', channel: 'email', name: 'We Miss You', sentAt: at(41, 11, 20), status: 'delivered', source: 'Campaign' },
      { id: 'demo-8', channel: 'sms', name: 'Bank holiday hours', sentAt: at(52, 14, 5), status: 'failed', source: 'Campaign' },
    ];
  };

  // Messages (Charlie, 2026-10-01): one tab for everything this client has
  // sent and been sent, as conversations: direct texts and emails, Bailey's
  // chats, marketing and journeys, reminders. Consent is its strip and
  // history. Marketing, consent and journeys load here and are passed in.
  renderMessage(initialFilter) {
    if (!this.state.messagesLoaded && !this.state.messagesLoading) this.loadClientMessages();
    if (!this.state.consentLoaded && !this.state.consentLoading) this.loadConsentHistory();
    if (!this.state.journeysLoaded && !this.state.journeysLoading) this.loadClientJourneys();
    const client = this.props.clientDetail?.clientDetail;
    const clientName = [client?.firstName, client?.lastName].filter(Boolean).join(' ') || client?.name || '';
    return (
      <div className="cdp-tab-content">
        <ClientMessagesTab
          key={this.props.clientId}
          clientId={this.props.clientId}
          clientName={clientName}
          initialFilter={initialFilter || 'all'}
          openChatAt={this.state.openChatAt}
          marketing={{
            items: this.state.clientMessages || [],
            hasMore: this.state.messagesHasMore,
            loadingMore: this.state.messagesLoadingMore,
            loadMore: this.loadMoreClientMessages,
          }}
          journeys={{ runs: this.state.journeyRuns || [], loading: this.state.journeysLoading }}
          consent={{ current: this.state.consentCurrent, render: () => this.renderConsentHistorySubTab() }}
        />
      </div>
    );
  }

  renderMessagesSubTab() {
    const { clientMessages, messagesLoading, messagesLoaded } = this.state;
    const items = clientMessages || [];
    if (messagesLoading || !messagesLoaded) {
      return (
        <div style={{ paddingTop: 10 }}>
          {[1, 2, 3].map((i) => (
            <div key={i} style={{ height: 56, borderRadius: 12, background: '#F2F2F7', marginBottom: 10 }} />
          ))}
        </div>
      );
    }
    if (items.length === 0 && !this.state.messagesDemo) {
      return (
        <div style={{ textAlign: 'center', padding: '36px 16px' }}>
          <p style={{ fontSize: 14, fontWeight: 600, color: '#4B4B52', margin: '0 0 6px' }}>
            {this.state.messagesError ? 'Couldn’t load messages' : 'No marketing messages yet'}
          </p>
          <p style={{ fontSize: 12.5, color: '#8E8E93', lineHeight: 1.55, margin: '0 0 16px', maxWidth: 300, marginLeft: 'auto', marginRight: 'auto' }}>
            {this.state.messagesError
              ? 'Something went wrong fetching this client’s messages. Please try again.'
              : 'Emails and texts this client receives will appear here, with delivery and engagement.'}
          </p>
          <button
            type="button"
            onClick={() => this.state.messagesError
              ? this.setState({ messagesLoaded: false, messagesLoading: false }, this.loadClientMessages)
              : this.setState({ messagesDemo: true })}
            style={{ padding: '8px 16px', borderRadius: 100, border: '1px solid #007EA0', background: '#fff', fontSize: 12.5, fontWeight: 700, color: '#007EA0', cursor: 'pointer', fontFamily: 'inherit' }}
          >
            {this.state.messagesError ? 'Try again' : 'Preview with sample data'}
          </button>
        </div>
      );
    }
    return (
      <>
        {this.state.messagesDemo && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 16px', background: 'rgba(0,126,160,0.08)', border: '1px solid rgba(0,126,160,0.2)', borderRadius: 12, margin: '6px 0 14px' }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: '#007EA0', flex: 1 }}>Sample data. Nothing here is real.</span>
            <button type="button" onClick={() => this.setState({ messagesDemo: false })} style={{ border: 'none', background: 'none', fontSize: 12, fontWeight: 700, color: '#007EA0', cursor: 'pointer', fontFamily: 'inherit', textDecoration: 'underline' }}>Exit</button>
          </div>
        )}
        {(this.state.messagesDemo ? this.buildSampleMessages() : items).map((msg, i) => {
          const isSms = (msg.channel || msg.type) === 'sms';
          const status = (msg.status || 'sent').toLowerCase();
          const positive = status === 'opened' || status === 'clicked' || status === 'booked';
          return (
            <div key={msg.id || i} style={{ display: 'flex', alignItems: 'center', gap: 15, padding: '21px 6px', borderBottom: '1px solid #F2F2F7' }}>
              <span style={{
                width: 42, height: 42, borderRadius: 12, flexShrink: 0,
                background: 'rgba(0,126,160,0.08)', color: '#007EA0',
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center'
              }}>
                {isSms ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></svg>
                )}
              </span>
              <span style={{ flex: 1, minWidth: 0 }}>
                <span style={{ display: 'block', fontSize: 14, fontWeight: 600, color: '#1A1A1E', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {msg.name || msg.subject || (isSms ? 'Text message' : 'Email')}
                </span>
                <span style={{ display: 'block', fontSize: 12.5, color: '#8E8E93', marginTop: 4 }}>
                  {msg.sentAt ? `${new Date(msg.sentAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })} at ${new Date(msg.sentAt).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}` : ''}
                  {msg.source ? ` · ${msg.source}` : ''}
                </span>
              </span>
              <span style={{
                fontSize: 11.5, fontWeight: 700, textTransform: 'capitalize', borderRadius: 100, padding: '4px 11px', flexShrink: 0,
                color: positive ? '#007EA0' : status === 'failed' || status === 'bounced' ? '#B14438' : '#8E8E93',
                background: positive ? 'rgba(0,126,160,0.1)' : status === 'failed' || status === 'bounced' ? 'rgba(177,68,56,0.08)' : '#F2F2F7'
              }}>
                {status}
              </span>
            </div>
          );
        })}
        {!this.state.messagesDemo && this.renderLoadMore(this.state.messagesHasMore, this.state.messagesLoadingMore, this.loadMoreClientMessages)}
      </>
    );
  }

  // Consent audit trail: current marketable state per channel, then a merged
  // chronological timeline of consent changes + suppressions (newest first).
  renderConsentHistorySubTab() {
    const { consentLoading, consentLoaded, consentCurrent, consentHistory, consentSuppressions, consentError } = this.state;
    if (consentLoading || !consentLoaded) {
      return (
        <div style={{ paddingTop: 10 }}>
          {[1, 2, 3].map((i) => (
            <div key={i} style={{ height: 48, borderRadius: 12, background: '#F2F2F7', marginBottom: 10 }} />
          ))}
        </div>
      );
    }
    if (consentError) {
      return (
        <div style={{ textAlign: 'center', padding: '36px 16px' }}>
          <p style={{ fontSize: 14, fontWeight: 600, color: '#4B4B52', margin: '0 0 6px' }}>Couldn&rsquo;t load consent history</p>
          <p style={{ fontSize: 12.5, color: '#8E8E93', lineHeight: 1.55, margin: '0 0 16px', maxWidth: 300, marginLeft: 'auto', marginRight: 'auto' }}>
            Something went wrong. Please try again.
          </p>
          <button
            type="button"
            onClick={() => this.setState({ consentLoaded: false, consentLoading: false }, this.loadConsentHistory)}
            style={{ padding: '8px 16px', borderRadius: 100, border: '1px solid #007EA0', background: '#fff', fontSize: 12.5, fontWeight: 700, color: '#007EA0', cursor: 'pointer', fontFamily: 'inherit' }}
          >
            Try again
          </button>
        </div>
      );
    }

    // Current marketable state per channel. Opt-out model: marketable unless
    // the stored value is EXPLICITLY false.
    const emailMarketable = consentCurrent?.emailMarketingConsent !== false;
    const smsMarketable = consentCurrent?.smsMarketingConsent !== false;
    const chip = (label, marketable) => (
      <div style={{ flex: 1, padding: '10px 12px', borderRadius: 10, background: '#F8F8FA', border: '1px solid #EFEFF2' }}>
        <span style={{ display: 'block', fontSize: 12, color: '#8E8E93', marginBottom: 4 }}>{label}</span>
        <span style={{ fontSize: 13, fontWeight: 700, color: marketable ? '#007EA0' : '#B14438' }}>
          {marketable ? 'Marketable' : 'Opted out'}
        </span>
      </div>
    );

    // Fold consent changes + suppressions into one timeline, newest first.
    const channelLabel = (ch) => (ch === 'sms' ? 'SMS marketing' : 'Email marketing');
    const events = [];
    (consentHistory || []).forEach((h) => {
      events.push({
        at: h.at,
        title: `${channelLabel(h.channel)} turned ${h.granted ? 'ON' : 'OFF'}`,
        by: h.byName || 'client',
        source: this.consentSourceLabel(h.source),
        granted: h.granted,
      });
    });
    (consentSuppressions || []).forEach((s) => {
      events.push({
        at: s.at,
        title: `${channelLabel(s.channel)} turned OFF`,
        by: null,
        source: this.consentSourceLabel(s.source),
        granted: false,
      });
    });
    events.sort((a, b) => new Date(b.at || 0) - new Date(a.at || 0));

    return (
      <>
        <div style={{ display: 'flex', gap: 10, margin: '6px 0 18px' }}>
          {chip('Email', emailMarketable)}
          {chip('SMS', smsMarketable)}
        </div>
        {events.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '30px 16px' }}>
            <p style={{ fontSize: 14, fontWeight: 600, color: '#4B4B52', margin: '0 0 6px' }}>No consent changes yet</p>
            <p style={{ fontSize: 12.5, color: '#8E8E93', lineHeight: 1.55, margin: 0, maxWidth: 300, marginLeft: 'auto', marginRight: 'auto' }}>
              This client is marketable by default. Any opt-outs or opt-ins will show here.
            </p>
          </div>
        ) : (
          events.map((e, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 13, padding: '16px 6px', borderBottom: '1px solid #F2F2F7' }}>
              <span style={{
                width: 34, height: 34, borderRadius: '50%', flexShrink: 0, marginTop: 2,
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                background: e.granted ? 'rgba(0,126,160,0.1)' : 'rgba(177,68,56,0.08)',
                color: e.granted ? '#007EA0' : '#B14438',
              }}>
                {e.granted ? (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                ) : (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                )}
              </span>
              <span style={{ flex: 1, minWidth: 0 }}>
                <span style={{ display: 'block', fontSize: 14, fontWeight: 600, color: '#1A1A1E' }}>{e.title}</span>
                <span style={{ display: 'block', fontSize: 12.5, color: '#8E8E93', marginTop: 4 }}>
                  {e.at ? new Date(e.at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : ''}
                  {` · by ${e.by || 'client'}`}
                  {e.source ? ` · via ${e.source}` : ''}
                </span>
              </span>
            </div>
          ))
        )}
        {this.renderLoadMore(this.state.consentHasMore, this.state.consentLoadingMore, this.loadMoreConsentHistory)}
      </>
    );
  }

  renderForms() {
    const forms = this.state.clientForms;

    return (
      <div className="cdp-tab-content">
        {this.state.clientFormsLoading ? (
          <p className="cdp-empty">Loading forms...</p>
        ) : forms.length === 0 ? (
          <p className="cdp-empty">No forms sent yet</p>
        ) : (
          <>
            {forms.map((sub) => (
              <div key={sub._id} className={'cdp-form-card ' + sub.status}>
                <div className="cdp-form-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                  </svg>
                </div>
                <div className="cdp-form-body">
                  <p className="cdp-form-name">{sub.formName || sub.formTemplate?.name || 'Untitled Form'}</p>
                  <p className="cdp-form-date">
                    {sub.status === 'completed'
                      ? 'Submitted ' + moment(sub.completedAt || sub.updatedAt).format('DD MMM YYYY')
                      : 'Sent ' + moment(sub.sentAt || sub.createdAt).format('DD MMM YYYY')
                    }
                  </p>
                </div>
                <span className={'cdp-form-status ' + sub.status}>
                  {sub.status === 'completed' ? 'Done' : 'Pending'}
                </span>
                {sub.status === 'completed' ? (
                  <button className="cdp-form-action" onClick={() => this.navigateAway('/forms/submission/' + sub._id)}>View</button>
                ) : (
                  <button className="cdp-form-action" onClick={() => this.handleSendForm(sub.formTemplateId)}>Resend</button>
                )}
              </div>
            ))}
            {this.renderLoadMore(this.state.clientFormsHasMore, this.state.clientFormsLoadingMore, this.loadMoreClientForms)}
          </>
        )}
        <button className="cdp-send-form-btn" onClick={this.openSendFormModal}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
          </svg>
          Send Form
        </button>
      </div>
    );
  }

  renderDeleteConfirm() {
    if (!this.state.deleteClientModal) return null;
    return (
      <div className="cdp-confirm-overlay" onClick={() => this.setState({ deleteClientModal: false })}>
        <div className="cdp-confirm-card" onClick={e => e.stopPropagation()}>
          <div className="cdp-confirm-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
            </svg>
          </div>
          <h3 className="cdp-confirm-title">Delete Client</h3>
          <p className="cdp-confirm-text">Are you sure you want to delete this client? This action cannot be undone.</p>
          <div className="cdp-confirm-actions">
            <button className="cdp-btn-cancel" onClick={() => this.setState({ deleteClientModal: false })}>Cancel</button>
            <button className="cdp-btn-delete" onClick={this.deleteClient}>Delete</button>
          </div>
        </div>
      </div>
    );
  }

  renderSendFormModal() {
    if (!this.state.showSendFormModal) return null;
    return (
      <div className="cdp-send-modal-overlay" onClick={() => this.setState({ showSendFormModal: false })}>
        <div className="cdp-send-modal" onClick={e => e.stopPropagation()}>
          <div className="cdp-send-modal-header">
            <div>
              <h3 className="cdp-send-modal-title">Send Form</h3>
              <p className="cdp-send-modal-subtitle">Choose a form to send</p>
            </div>
            <button className="beu-icon-btn" onClick={() => this.setState({ showSendFormModal: false })}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
          <div className="cdp-send-modal-body">
            {this.state.availableFormsLoading ? (
              <p className="cdp-empty">Loading...</p>
            ) : this.state.availableForms.length === 0 ? (
              <p className="cdp-empty">No active forms available</p>
            ) : (
              this.state.availableForms.map((form) => (
                <div key={form._id} className="cdp-send-form-item">
                  <div className="cdp-send-form-item-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                    </svg>
                  </div>
                  <div className="cdp-send-form-item-info">
                    <span className="cdp-send-form-item-name">{form.name || 'Untitled Form'}</span>
                    <span className="cdp-send-form-item-meta">
                      {form.sections ? form.sections.length + ' section' + (form.sections.length !== 1 ? 's' : '') : 'Form'}
                    </span>
                  </div>
                  <button
                    className="cdp-send-form-item-btn"
                    disabled={this.state.sendingFormId === form._id}
                    onClick={() => this.handleSendForm(form._id)}
                  >
                    {this.state.sendingFormId === form._id ? 'Sending...' : 'Send'}
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    );
  }

  renderActiveTab() {
    switch (this.state.activeTab) {
      case 'bookings': return this.renderBookings();
      case 'notes': return this.renderNotes();
      case 'sales': return this.renderSales();
      case 'wallet': return this.renderWallet();
      case 'forms': return this.renderForms();
      case 'messages': return this.renderMessage();
      case 'photos': return this.renderPhotos();
      // Old links to the Bailey tab open Messages on its Bailey filter.
      case 'bailey': return CONCIERGE_VISIBLE ? this.renderMessage('bailey') : this.renderOverview();
      default: return this.renderOverview();
    }
  }

  render() {
    return (
      <>
        <SlidePanel ref={this.slidePanelRef} width={this.state.mergeView ? 760 : 'min(760px, 92vw)'} onClose={() => this.props.onClose(this._didDelete || false)} className="cdp-panel">
          {this.state.isLoading ? this.renderSkeleton() : (this.state.mergeView && this.state.mergeSuggestion) ? (
            <>
              {/* Merge flow — in-panel view (widened), back arrow returns to the client */}
              <div className="cdp-header">
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <button className="beu-icon-btn" onClick={() => this.setState({ mergeView: false })}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="15 18 9 12 15 6" />
                    </svg>
                  </button>
                  <h2 className="cdp-header-name">Merge clients</h2>
                </div>
              </div>
              <div className="cdp-body" style={{ padding: 0, display: 'flex', flexDirection: 'column' }}>
                <MergeClientsView
                  loserUserId={this.state.mergeSuggestion.loserUserId}
                  winnerUserId={this.state.mergeSuggestion.winnerUserId}
                  onBack={() => this.setState({ mergeView: false })}
                  onConfirmed={() => {
                    // The merged-away record may be THIS client — close the
                    // panel and let the list refresh rather than showing a
                    // dead record.
                    this.setState({ mergeView: false, mergeSuggestion: null });
                    this.props.onClose(true);
                  }}
                />
              </div>
            </>
          ) : this.state.editMode ? (
            <>
              {/* Edit Mode Header */}
              <div className="cdp-header">
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <button className="beu-icon-btn" onClick={() => this.setState({ editMode: false })}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="15 18 9 12 15 6" />
                    </svg>
                  </button>
                  <h2 className="cdp-header-name">Edit Client</h2>
                </div>
              </div>

              {/* Edit Form */}
              <div className="cdp-body" style={{ padding: 24 }}>
                <div className="sp-form">
                  <div className="sp-row">
                    <div className="sp-field">
                      <label className="sp-label">First Name *</label>
                      <input className="sp-input" value={this.state.editFirstName} onChange={e => this.setState({ editFirstName: e.target.value, editError: '' })} placeholder="First name" />
                    </div>
                    <div className="sp-field">
                      <label className="sp-label">Surname</label>
                      <input className="sp-input" value={this.state.editLastName} onChange={e => this.setState({ editLastName: e.target.value })} placeholder="Surname" />
                    </div>
                  </div>

                  <div className="sp-field">
                    <label className="sp-label">Email</label>
                    <input className="sp-input" type="email" value={this.state.editEmail} onChange={e => this.setState({ editEmail: e.target.value, editEmailError: '' })} placeholder="Email address" />
                    {this.state.editEmailError && <p className="sp-error">{this.state.editEmailError}</p>}
                  </div>

                  <div className="sp-field">
                    <label className="sp-label">Mobile Number</label>
                    <div className="sp-phone-wrapper">
                      <PhoneInput
                        international
                        defaultCountry="GB"
                        value={this.state.editPhone}
                        onChange={val => this.setState({ editPhone: val || '' })}
                        placeholder="Phone number"
                      />
                    </div>
                  </div>

                  <div className="sp-field">
                    <label className="sp-label">Birthday</label>
                    <button
                      type="button"
                      ref={el => this._dobAnchorRef = el}
                      className="sp-input acp-dob-trigger"
                      onClick={() => this.setState({ showBirthdayPicker: true })}
                    >
                      {this.state.editDob ? dateFormat(this.state.editDob, 'dd/mm/yyyy') : <span className="acp-dob-placeholder">DD/MM/YYYY</span>}
                    </button>
                    <BirthdayPicker
                      open={this.state.showBirthdayPicker}
                      selected={this.state.editDob}
                      onChange={date => this.setState({ editDob: date, showBirthdayPicker: false })}
                      onClose={() => this.setState({ showBirthdayPicker: false })}
                      anchorEl={this._dobAnchorRef}
                    />
                  </div>

                  <div className="sp-field">
                    <label className="sp-label">Notes</label>
                    <textarea className="sp-textarea" value={this.state.editNote} onChange={e => this.setState({ editNote: e.target.value })} placeholder="Client notes..." rows={4} />
                  </div>

                  {this.state.editError && <p className="sp-general-error">{this.state.editError}</p>}
                </div>
              </div>

              {/* Edit Footer */}
              <div className="cdp-edit-footer">
                <button className="sp-btn-secondary" onClick={() => this.setState({ editMode: false })}>Cancel</button>
                <button className="sp-btn-primary" onClick={this.saveEditClient} disabled={this.state.editSaving}>
                  {this.state.editSaving ? 'Saving...' : 'Save Changes'}
                </button>
              </div>
            </>
          ) : (
            <>
              {this.renderHeader()}
              {this.renderSummaryBar()}
              {this.renderTabs()}
              <div
                className="cdp-tab-swipe-wrap"
                onTouchStart={this.handleContentTouchStart}
                onTouchMove={this.handleContentTouchMove}
                onTouchEnd={this.handleContentTouchEnd}
                onTouchCancel={this.handleContentTouchEnd}
              >
                {this.renderActiveTab()}
              </div>
            </>
          )}
        </SlidePanel>
        {this.renderDeleteConfirm()}
        {this.renderSendFormModal()}
        {this.state.openBookingEvent && (
          <BookingDetailPanel
            event={this.state.openBookingEvent}
            bookingDate={this.state.openBookingEvent.date}
            onClose={() => this.setState({ openBookingEvent: null })}
            history={this.props.history}
            user={this.props.user}
            currencySymbol={this.props.user?.userInfo?.hairdresser?.currencySymbol || '£'}
            nested
          />
        )}
      </>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { clientDetail, user } = state;
  const photosEntry = state.clientPhotos?.byClientId?.[ownProps.clientId];
  const photosByBookingId = {};
  if (photosEntry?.items) {
    photosEntry.items.forEach((p) => {
      if (!p.bookingId) return;
      if (!photosByBookingId[p.bookingId]) photosByBookingId[p.bookingId] = [];
      photosByBookingId[p.bookingId].push(p);
    });
  }
  return { user, clientDetail, photosByBookingId };
}

export default connect(mapStateToProps)(ClientDetailPanel);
